// src/schemas/typebox/admin/schema-validators.ts
import { Type as Type2 } from "@sinclair/typebox";

// src/schemas/typebox/schema-validator.ts
import { Value } from "@sinclair/typebox/value";
var SchemaValidator = class {
  // readonly #validator;
  constructor(schema) {
    this.validate = (obj) => {
      return Value.Check(this.schema, obj);
    };
    this.schema = schema;
  }
};

// src/schemas/typebox/shared-schemas.ts
import { Type } from "@sinclair/typebox";
function OptionalOrNull(type) {
  return Type.Optional(Type.Union([Type.Null(), type]));
}
function PaginatedResults(type, keyName = "results") {
  const properties = {
    currentPage: Type.Number(),
    totalElements: Type.Number(),
    totalPages: Type.Number(),
    [keyName]: Type.Array(type)
  };
  return Type.Object(properties);
}

// src/schemas/typebox/admin/schema-validators.ts
var activeVerityDeployment = new SchemaValidator(
  Type2.Object({
    deploymentId: OptionalOrNull(Type2.String()),
    clientId: OptionalOrNull(Type2.String()),
    iss: OptionalOrNull(Type2.String())
  })
);
var deployment = new SchemaValidator(
  Type2.Object({
    id: OptionalOrNull(Type2.Number()),
    deploymentId: Type2.String(),
    lti1p3ClientRegistrationId: Type2.Number(),
    instituteId: OptionalOrNull(Type2.String())
  })
);
var deployments = new SchemaValidator(
  Type2.Object({
    deployments: Type2.Array(
      Type2.Object({
        id: Type2.Number(),
        deploymentId: Type2.String(),
        lti1p3ClientRegistrationId: Type2.Number(),
        instituteId: OptionalOrNull(Type2.String())
      })
    ),
    instituteId: Type2.String()
  })
);
var clientRegistrationId = new SchemaValidator(
  Type2.Object({
    clientRegistrations: Type2.Array(
      Type2.Object({
        id: Type2.Number()
      })
    )
  })
);
var upsertedClientRegistrationId = new SchemaValidator(Type2.Number());
var clientRegistration = new SchemaValidator(
  Type2.Object({
    id: Type2.Number(),
    iss: Type2.String(),
    clientId: Type2.String(),
    authorizationUri: Type2.String(),
    jwkSetUri: Type2.String(),
    instituteId: Type2.String()
  })
);
var paymentType = Type2.Union([Type2.Literal("assessment"), Type2.Literal("attempt")]);
var currency = Type2.Union([Type2.Literal("usd"), Type2.Literal("cad"), Type2.Literal("eur"), Type2.Literal("gbp")]);
var basePaymentSettingsSchema = Type2.Object({
  enabled: Type2.Boolean(),
  automatedType: paymentType,
  automatedProctoringPrice: Type2.Number(),
  liveProctoringType: paymentType,
  liveProctoringPrice: Type2.Number(),
  liveCheckInType: paymentType,
  liveCheckInPrice: Type2.Number(),
  livePostReviewType: paymentType,
  livePostReviewPrice: Type2.Number(),
  currency
});
var institutePaymentSettings = new SchemaValidator(
  Type2.Composite([
    Type2.Object({
      instituteId: Type2.Number(),
      enabled: basePaymentSettingsSchema.properties.enabled
    }),
    Type2.Partial(Type2.Omit(basePaymentSettingsSchema, ["enabled"]))
  ])
);
var updateInstitutePaymentSettingsRequest = new SchemaValidator(basePaymentSettingsSchema);
var schema_validators_default = {
  activeVerityDeployment,
  deployment,
  deployments,
  clientRegistrationId,
  upsertedClientRegistrationId,
  clientRegistration,
  institutePaymentSettings,
  updateInstitutePaymentSettingsRequest
};

// src/schemas/typebox/assessment/schema-validators.ts
import { Type as Type4 } from "@sinclair/typebox";

// src/schemas/typebox/verity-options/schema-validators.ts
import { Type as Type3 } from "@sinclair/typebox";
var recordingModeType = Type3.Union([Type3.Literal("off"), Type3.Literal("normal"), Type3.Literal("strict")]);
var proctoringOptionsType = Type3.Object({
  enforceLockdown: Type3.Boolean(),
  enforceMobile: Type3.Boolean(),
  isExtension: Type3.Boolean(),
  isLockdown: Type3.Boolean(),
  isMobile: Type3.Boolean(),
  isChromeOs: Type3.Boolean(),
  isBrowser: Type3.Boolean(),
  videoRecordingMode: recordingModeType,
  secondaryVideoRecordingMode: recordingModeType,
  audioRecordingMode: recordingModeType,
  recordScreen: Type3.Boolean(),
  recordWebTraffic: Type3.Boolean(),
  detectSidePanel: Type3.Boolean(),
  excludedWebTrafficRecordingUrls: OptionalOrNull(Type3.Array(Type3.String())),
  recordClipboard: Type3.Boolean(),
  recordInput: Type3.Boolean(),
  oneScreenEnforcementMode: recordingModeType,
  disableNewTab: Type3.Boolean(),
  closeOpenTabs: Type3.Boolean(),
  tabWhiteList: OptionalOrNull(Type3.Array(Type3.String())),
  tabBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  keyboardShortcutBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  disableClipboardMode: Type3.Union([Type3.Literal("off"), Type3.Literal("tab"), Type3.Literal("system")]),
  enableGuidedAccessMode: Type3.Boolean(),
  restrictHandoffMode: recordingModeType,
  disableSpellcheck: Type3.Boolean(),
  disablePrinting: Type3.Boolean(),
  disableRightClick: Type3.Boolean(),
  extensionBlockMode: recordingModeType,
  allowedExtensionsList: OptionalOrNull(Type3.Array(Type3.String())),
  logInstalledExtensions: Type3.Boolean(),
  disableDownloadFiles: Type3.Boolean(),
  hideOtherWindows: Type3.Boolean(),
  showRecordingPanel: Type3.Boolean(),
  idVerification: Type3.Boolean(),
  idVerificationEnableAi: Type3.Boolean(),
  faceTrackingMode: recordingModeType,
  objectDetectionMode: recordingModeType,
  applicationBlockMode: recordingModeType,
  blockWindowedApplications: Type3.Boolean(),
  applicationBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  allowedApplicationsList: OptionalOrNull(Type3.Array(Type3.String())),
  blockVirtualMachines: Type3.Boolean(),
  recordApplicationsActivity: Type3.Boolean(),
  logRunningApplications: Type3.Boolean(),
  isLiveProctored: Type3.Boolean(),
  isLivePopIn: Type3.Boolean(),
  enablePostReview: Type3.Boolean(),
  scanRoom: Type3.Boolean(),
  quietEnvironment: Type3.Boolean(),
  enableCalculator: Type3.Union([Type3.Literal("off"), Type3.Literal("scientific"), Type3.Literal("standard")]),
  enableWhiteboard: Type3.Boolean(),
  enableCodeEditor: Type3.Boolean(),
  codeEditorRoomId: OptionalOrNull(Type3.Array(Type3.String(), { maxItems: 1 })),
  uploadScratchNotes: Type3.Boolean(),
  idVerificationMode: recordingModeType,
  restrictDevices: Type3.Boolean(),
  enableManualEndProctoring: Type3.Boolean(),
  enableReferenceMaterial: Type3.Boolean(),
  referenceMaterialMode: Type3.Union([Type3.Literal("off"), Type3.Literal("instructor"), Type3.Literal("student")]),
  audioTranscription: Type3.Boolean(),
  flaggedKeywords: Type3.Union([
    Type3.Null(),
    Type3.Array(
      Type3.Object({
        keyword: Type3.String(),
        level: Type3.Optional(Type3.Number())
      })
    )
  ]),
  uploadSignature: Type3.Boolean(),
  enableGeofence: Type3.Boolean(),
  geofenceLocations: OptionalOrNull(
    Type3.Array(
      Type3.Object({
        longitude: Type3.Number(),
        latitude: Type3.Number(),
        radius: Type3.Number(),
        name: Type3.String(),
        isMetric: Type3.Boolean()
      })
    )
  ),
  disableVirtualCamera: Type3.Boolean(),
  enableIpAddressRestriction: Type3.Boolean(),
  allowedIpAddresses: OptionalOrNull(
    Type3.Array(
      Type3.Object({
        min: Type3.String(),
        max: Type3.String()
      })
    )
  )
});
var chromeOsAccessType = OptionalOrNull(
  Type3.Union([Type3.Literal("managed-guest-session"), Type3.Literal("all")])
);
var candidateInterviewOptionsBaseType = Type3.Object({
  candidateEmail: Type3.String(),
  candidateName: Type3.String(),
  meetingLink: Type3.String(),
  notes: OptionalOrNull(Type3.String()),
  positionName: Type3.String(),
  title: Type3.String(),
  videoPlatform: Type3.Union([
    Type3.Literal("other"),
    Type3.Literal("zoom"),
    Type3.Literal("teams"),
    Type3.Literal("googleMeet")
  ])
});
var candidateInterviewOptionsGetType = Type3.Intersect([
  candidateInterviewOptionsBaseType,
  Type3.Object({
    id: Type3.Number()
  })
]);
var candidateInterviewOptionsSaveType = Type3.Intersect([
  candidateInterviewOptionsBaseType,
  Type3.Object({
    id: OptionalOrNull(Type3.Number())
  })
]);
var verityOptions = new SchemaValidator(
  Type3.Object({
    ...proctoringOptionsType.properties,
    lmsQuizId: OptionalOrNull(Type3.Number()),
    enabled: Type3.Boolean(),
    requiresIncognito: Type3.Boolean(),
    chromeOsAccess: chromeOsAccessType,
    isChromeExtension: Type3.Boolean(),
    isFirefoxExtension: Type3.Boolean(),
    isSafariExtension: Type3.Boolean(),
    delayRecordingUntilAssessmentStart: Type3.Boolean(),
    automaticallyAddedAllowedUrls: OptionalOrNull(Type3.Array(Type3.String())),
    logEvents: Type3.Boolean(),
    paymentEnabled: Type3.Boolean(),
    preferredSetupUiVersion: Type3.String(),
    password: OptionalOrNull(Type3.String()),
    thirdPartyAssessmentOptions: OptionalOrNull(
      Type3.Object({
        thirdPartyUrl: OptionalOrNull(Type3.String()),
        password: OptionalOrNull(Type3.String()),
        thirdPartyPlatformId: OptionalOrNull(Type3.Number())
      })
    )
  })
);
var applicationResponse = new SchemaValidator(
  Type3.Array(
    Type3.Object({
      id: Type3.Number(),
      name: Type3.String(),
      processName: Type3.Array(Type3.String()),
      iconSvg: Type3.String(),
      type: Type3.Union([
        Type3.Literal("Browser"),
        Type3.Literal("Communication"),
        Type3.Literal("Screen Sharing"),
        Type3.Literal("Other")
      ]),
      createdAt: Type3.String(),
      updatedAt: Type3.String()
    })
  )
);
var extensionResponse = new SchemaValidator(
  Type3.Array(
    Type3.Object({
      id: Type3.Number(),
      extensionId: Type3.String(),
      extensionName: Type3.String(),
      iconSvg: Type3.String(),
      type: Type3.Union([Type3.Literal("Writing Tools"), Type3.Literal("Screen Capture Tools"), Type3.Literal("Other")]),
      createdAt: Type3.String(),
      updatedAt: Type3.String()
    })
  )
);
var schema_validators_default2 = {
  verityOptions,
  applicationResponse,
  extensionResponse
};

// src/schemas/typebox/assessment/schema-validators.ts
var assessmentInfoType = Type4.Object({
  id: Type4.Number(),
  courseId: Type4.Number(),
  quizId: Type4.String(),
  quizInfo: OptionalOrNull(
    Type4.Union([
      Type4.String(),
      Type4.Intersect([
        Type4.Object({
          name: OptionalOrNull(Type4.String())
        }),
        Type4.Record(Type4.String(), Type4.Any())
      ])
    ])
  ),
  isDeleted: Type4.Boolean(),
  createdAt: OptionalOrNull(Type4.Union([Type4.Number(), Type4.String()])),
  updatedAt: OptionalOrNull(Type4.Union([Type4.Number(), Type4.String()])),
  sourcesLastScanned: Type4.Union([Type4.String(), Type4.Null()])
});
var audioRecordingConfiguration = new SchemaValidator(
  Type4.Object({
    maxRecordingLengthSeconds: Type4.Number(),
    minRecordingLengthSeconds: Type4.Number(),
    // Optional for backward compatibility — configs stored before this field existed have no value
    // and are treated as "audio" everywhere this is read.
    recordingMode: Type4.Optional(Type4.Union([Type4.Literal("audio"), Type4.Literal("video")]))
  })
);
var fileSubmissionConfiguration = new SchemaValidator(
  Type4.Object({
    maxUploadedFiles: Type4.Number(),
    maxUploadedFileSizeBytes: Type4.Number(),
    acceptedUploadedFileFormat: Type4.Array(Type4.String())
  })
);
var multipleChoiceConfiguration = new SchemaValidator(
  Type4.Object({
    allowMultipleAnswer: Type4.Boolean()
  })
);
var quizQuestionConfiguration = new SchemaValidator(
  Type4.Union([
    audioRecordingConfiguration.schema,
    fileSubmissionConfiguration.schema,
    multipleChoiceConfiguration.schema
  ])
);
var baseQuizQuestionType = Type4.Object({
  id: Type4.Optional(Type4.Number()),
  questionText: Type4.String(),
  questionOrder: Type4.Number(),
  questionType: Type4.Union([
    Type4.Literal("MultipleChoice"),
    Type4.Literal("TrueFalse"),
    Type4.Literal("FillInTheBlank"),
    Type4.Literal("Matching"),
    Type4.Literal("FileUpload"),
    Type4.Literal("Essay"),
    Type4.Literal("Ordering"),
    Type4.Literal("AudioRecording"),
    Type4.Literal("FileSubmission"),
    Type4.Literal("DragAndDrop"),
    Type4.Literal("Dropdown"),
    Type4.Literal("Spreadsheet"),
    Type4.Literal("Coding")
  ]),
  correctionPoints: Type4.Number(),
  configuration: OptionalOrNull(quizQuestionConfiguration.schema)
});
var choiceAnswer = new SchemaValidator(Type4.Array(Type4.Number()));
var fitbAnswer = new SchemaValidator(Type4.Record(Type4.Number(), Type4.String()));
var matchingAnswer = new SchemaValidator(Type4.Record(Type4.String(), Type4.String()));
var essayAnswer = new SchemaValidator(Type4.String());
var orderingAnswer = new SchemaValidator(Type4.Array(Type4.String()));
var quizQuestionSubmissionFile = new SchemaValidator(
  Type4.Object({
    fileName: Type4.String(),
    fileUrl: Type4.Union([Type4.String(), Type4.Null()]),
    fileSize: Type4.Optional(Type4.Number())
  })
);
var audioRecordingAnswer = new SchemaValidator(Type4.Array(quizQuestionSubmissionFile.schema));
var fileSubmissionAnswer = new SchemaValidator(Type4.Array(quizQuestionSubmissionFile.schema));
var dragAndDropAnswer = new SchemaValidator(Type4.Record(Type4.String(), Type4.String()));
var dropdownAnswer = new SchemaValidator(Type4.Record(Type4.String(), Type4.String()));
var spreadsheetAnswer = new SchemaValidator(Type4.Array(Type4.Array(Type4.Object({ text: Type4.String() }))));
var codingLanguage = new SchemaValidator(
  Type4.Union([
    Type4.Literal("javascript"),
    Type4.Literal("python"),
    Type4.Literal("java"),
    Type4.Literal("cpp"),
    Type4.Literal("c"),
    Type4.Literal("php"),
    Type4.Literal("csharp")
  ])
);
var codingAnswer = new SchemaValidator(Type4.Object({ code: Type4.String(), language: codingLanguage.schema }));
var quizAnswer = new SchemaValidator(
  Type4.Union([
    choiceAnswer.schema,
    fitbAnswer.schema,
    matchingAnswer.schema,
    essayAnswer.schema,
    orderingAnswer.schema,
    audioRecordingAnswer.schema,
    fileSubmissionAnswer.schema,
    dragAndDropAnswer.schema,
    dropdownAnswer.schema,
    spreadsheetAnswer.schema,
    codingAnswer.schema
  ])
);
var mcOption = new SchemaValidator(
  Type4.Object({
    text: Type4.String()
  })
);
var mcOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...mcOption.schema.properties,
    weightage: Type4.Number()
  })
);
var tfOption = new SchemaValidator(
  Type4.Object({
    text: Type4.Union([Type4.Literal("True"), Type4.Literal("False")])
  })
);
var tfOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...tfOption.schema.properties,
    weightage: Type4.Number()
  })
);
var fitbBlankAnswer = new SchemaValidator(
  Type4.Object({
    blankId: Type4.Number()
  })
);
var fitbBlankAnswerInstructor = new SchemaValidator(
  Type4.Object({
    ...fitbBlankAnswer.schema.properties,
    weightage: Type4.Number(),
    answers: Type4.Array(Type4.String())
  })
);
var matchingPair = new SchemaValidator(
  Type4.Union([
    Type4.Object({ premise: Type4.String(), response: Type4.String() }),
    Type4.Object({ response: Type4.String() })
  ])
);
var matchingPairInstructor = new SchemaValidator(
  Type4.Union([
    Type4.Object({ premise: Type4.String(), response: Type4.String(), weightage: Type4.Number() }),
    Type4.Object({ response: Type4.String(), weightage: Type4.Number() })
  ])
);
var fileUploadOption = new SchemaValidator(
  Type4.Object({
    allowedFileTypes: Type4.Array(Type4.String())
  })
);
var essayOption = new SchemaValidator(Type4.Null());
var orderingOption = new SchemaValidator(
  Type4.Object({
    id: Type4.String(),
    text: Type4.String()
  })
);
var orderingOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...orderingOption.schema.properties,
    order: Type4.Number()
  })
);
var audioRecordingOption = essayOption;
var fileSubmissionOption = essayOption;
var codingOption = essayOption;
var dragAndDropOption = new SchemaValidator(
  Type4.Object({
    text: Type4.String()
  })
);
var dragAndDropOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...dragAndDropOption.schema.properties,
    blankId: Type4.Optional(Type4.Number()),
    weightage: Type4.Optional(Type4.Number())
  })
);
var dropdownChoice = new SchemaValidator(
  Type4.Object({
    text: Type4.String()
  })
);
var dropdownChoiceInstructor = new SchemaValidator(
  Type4.Object({
    ...dropdownChoice.schema.properties,
    weightage: Type4.Number()
  })
);
var dropdownBlank = new SchemaValidator(
  Type4.Object({
    blankId: Type4.Number(),
    options: Type4.Array(dropdownChoice.schema)
  })
);
var dropdownBlankInstructor = new SchemaValidator(
  Type4.Object({
    blankId: Type4.Number(),
    options: Type4.Array(dropdownChoiceInstructor.schema)
  })
);
var spreadsheetCell = new SchemaValidator(
  Type4.Union([Type4.Object({ isGradeCell: Type4.Literal(true) }), Type4.Object({ text: Type4.Optional(Type4.String()) })])
);
var spreadsheetCellInstructor = new SchemaValidator(
  Type4.Union([
    Type4.Object({ isGradeCell: Type4.Literal(true), text: Type4.String(), weightage: Type4.Number() }),
    Type4.Object({ text: Type4.Optional(Type4.String()) })
  ])
);
var spreadsheetRow = new SchemaValidator(Type4.Array(spreadsheetCell.schema));
var spreadsheetRowInstructor = new SchemaValidator(Type4.Array(spreadsheetCellInstructor.schema));
var studentOptionsUnion = new SchemaValidator(
  Type4.Union([
    Type4.Array(mcOption.schema),
    Type4.Array(tfOption.schema),
    Type4.Array(fitbBlankAnswer.schema),
    Type4.Array(matchingPair.schema),
    fileUploadOption.schema,
    essayOption.schema,
    Type4.Array(orderingOption.schema),
    audioRecordingOption.schema,
    fileSubmissionOption.schema,
    codingOption.schema,
    Type4.Array(dragAndDropOption.schema),
    Type4.Array(dropdownBlank.schema),
    Type4.Array(spreadsheetRow.schema)
  ])
);
var instructorOptionsUnion = new SchemaValidator(
  Type4.Union([
    Type4.Array(mcOptionInstructor.schema),
    Type4.Array(tfOptionInstructor.schema),
    Type4.Array(fitbBlankAnswerInstructor.schema),
    Type4.Array(matchingPairInstructor.schema),
    fileUploadOption.schema,
    essayOption.schema,
    Type4.Array(orderingOptionInstructor.schema),
    audioRecordingOption.schema,
    fileSubmissionOption.schema,
    codingOption.schema,
    Type4.Array(dragAndDropOptionInstructor.schema),
    Type4.Array(dropdownBlankInstructor.schema),
    Type4.Array(spreadsheetRowInstructor.schema)
  ])
);
var studentQuizQuestion = new SchemaValidator(
  Type4.Object({
    ...baseQuizQuestionType.properties,
    options: OptionalOrNull(studentOptionsUnion.schema)
  })
);
var instructorQuizQuestion = new SchemaValidator(
  Type4.Object({
    ...baseQuizQuestionType.properties,
    options: OptionalOrNull(instructorOptionsUnion.schema),
    aiGradingEnabled: OptionalOrNull(Type4.Boolean()),
    aiGradingCriteria: OptionalOrNull(Type4.String())
  })
);
var scoringStrategyType = new SchemaValidator(
  Type4.Union([Type4.Literal("highest"), Type4.Literal("latest"), Type4.Literal("first")])
);
var verityAssessmentType = Type4.Object({
  quizId: Type4.Number(),
  type: Type4.Union([Type4.Literal("quiz"), Type4.Literal("assignment")]),
  isPublished: Type4.Boolean(),
  syncGradebook: OptionalOrNull(Type4.Boolean()),
  startTime: Type4.String(),
  endTime: Type4.String(),
  allowLateSubmission: Type4.Boolean(),
  lateSubmissionDate: OptionalOrNull(Type4.String()),
  shuffleQuestions: OptionalOrNull(Type4.Boolean()),
  questionsPerPage: OptionalOrNull(Type4.Number()),
  numAttempts: Type4.Number(),
  showScoreOnSubmit: OptionalOrNull(Type4.Boolean()),
  duration: OptionalOrNull(Type4.Number()),
  description: OptionalOrNull(Type4.String()),
  moduleId: OptionalOrNull(Type4.String()),
  scoringStrategy: scoringStrategyType.schema
});
var studentVerityAssessmentType = Type4.Object({
  ...verityAssessmentType.properties,
  questions: OptionalOrNull(Type4.Array(studentQuizQuestion.schema))
});
var instructorVerityAssessmentType = Type4.Object({
  ...verityAssessmentType.properties,
  questions: OptionalOrNull(Type4.Array(instructorQuizQuestion.schema))
});
var verityAssessment = new SchemaValidator(Type4.Union([studentVerityAssessmentType, instructorVerityAssessmentType]));
var assessmentInfo = new SchemaValidator(assessmentInfoType);
var assessmentInfoArray = new SchemaValidator(Type4.Array(assessmentInfoType));
var assessmentInfoList = new SchemaValidator(
  Type4.Array(
    Type4.Intersect([
      assessmentInfoType,
      Type4.Object({
        hasDecoySite: Type4.Boolean(),
        proctoringOptions: OptionalOrNull(
          Type4.Object({
            enabled: OptionalOrNull(Type4.Boolean()),
            enabledIgnoringAccommodations: OptionalOrNull(Type4.Boolean()),
            hasThirdPartyUrl: OptionalOrNull(Type4.Boolean()),
            isLiveProctored: OptionalOrNull(Type4.Boolean()),
            isLivePopIn: OptionalOrNull(Type4.Boolean()),
            enablePostReview: OptionalOrNull(Type4.Boolean()),
            password: OptionalOrNull(Type4.String()),
            isExtension: OptionalOrNull(Type4.Boolean()),
            isLockdown: OptionalOrNull(Type4.Boolean()),
            isMobile: OptionalOrNull(Type4.Boolean()),
            isBrowser: OptionalOrNull(Type4.Boolean()),
            chromeOsAccess: chromeOsAccessType,
            requiresIncognito: OptionalOrNull(Type4.Boolean()),
            candidateInterviewOptions: OptionalOrNull(candidateInterviewOptionsGetType),
            thirdPartyAssessmentOptions: OptionalOrNull(
              Type4.Object({
                thirdPartyUrl: OptionalOrNull(Type4.String()),
                password: OptionalOrNull(Type4.String()),
                thirdPartyPlatformId: OptionalOrNull(Type4.Number())
              })
            )
          })
        ),
        proctoringAssessmentConfiguration: OptionalOrNull(
          Type4.Object(
            {
              thirdPartyAssessmentOption: OptionalOrNull(
                Type4.Object({
                  thirdPartyUrl: OptionalOrNull(Type4.String()),
                  password: OptionalOrNull(Type4.String()),
                  thirdPartyPlatformId: OptionalOrNull(Type4.Number())
                })
              )
            },
            { additionalProperties: true }
          )
        ),
        verityAssessment: OptionalOrNull(verityAssessment.schema)
      })
    ])
  )
);
var lmsAssessmentInfo = new SchemaValidator(
  Type4.Object({
    launchLink: OptionalOrNull(Type4.String())
  })
);
var standaloneStudent = Type4.Object({
  userId: Type4.Number(),
  firstName: Type4.String(),
  lastName: Type4.String(),
  email: Type4.String()
});
var standaloneStudentList = new SchemaValidator(Type4.Array(standaloneStudent));
var d2lContentQuizzes = new SchemaValidator(
  Type4.Array(
    Type4.Object({
      id: Type4.Number(),
      quizId: Type4.String()
    })
  )
);
var d2lContentPlatform = new SchemaValidator(Type4.Number());
var verityEnabledAssessment = new SchemaValidator(
  Type4.Object({
    quizId: Type4.String()
  })
);
var verityEnabledAssessments = new SchemaValidator(Type4.Array(verityEnabledAssessment.schema));
var lmsThirdPartyQuiz = new SchemaValidator(
  Type4.Object({
    quizId: Type4.String(),
    platformId: Type4.Union([Type4.Number(), Type4.Null()])
  })
);
var lmsThirdPartyQuizzes = new SchemaValidator(Type4.Array(lmsThirdPartyQuiz.schema));
var lmsThirdPartyQuizWithActivityUrl = new SchemaValidator(
  Type4.Intersect([
    lmsThirdPartyQuiz.schema,
    Type4.Object({
      activityUrl: Type4.Union([Type4.String(), Type4.Null()])
    })
  ])
);
var lmsThirdPartyQuizzesWithActivityUrl = new SchemaValidator(Type4.Array(lmsThirdPartyQuizWithActivityUrl.schema));
var suffixUpdateResult = new SchemaValidator(
  Type4.Object({
    ok: Type4.Boolean(),
    exists: Type4.Boolean(),
    newName: Type4.Union([Type4.String(), Type4.Null()])
  })
);
var assessmentMonthlyCountType = Type4.Object({
  count: Type4.Number(),
  monthlyCounts: Type4.Array(Type4.Number())
});
var assessmentMonthlyCountList = new SchemaValidator(
  Type4.Object({
    liveAssessments: assessmentMonthlyCountType,
    nonLiveAssessments: assessmentMonthlyCountType
  })
);
var validate = new SchemaValidator(
  Type4.Object({
    didValidate: Type4.Boolean(),
    doPasswordsMatch: Type4.Boolean(),
    isPasswordRequired: Type4.Boolean()
  })
);
var synchronize = new SchemaValidator(
  Type4.Object({
    didSynchronize: Type4.Boolean(),
    doPasswordsMatch: Type4.Boolean(),
    isPasswordRequired: Type4.Boolean()
  })
);
var lmsPassword = new SchemaValidator(
  Type4.Object({
    password: Type4.Union([Type4.String(), Type4.Null()])
  })
);
var assessmentQuestionType = Type4.Object({
  id: Type4.Number(),
  createdAt: Type4.String(),
  updatedAt: Type4.String(),
  assessmentId: Type4.Number(),
  lmsProvidedQuestionId: Type4.Union([Type4.String(), Type4.Null()]),
  title: Type4.Union([Type4.String(), Type4.Null()]),
  bodyHtml: Type4.Union([Type4.String(), Type4.Null()]),
  bodyText: Type4.Union([Type4.String(), Type4.Null()]),
  sources: Type4.Union([Type4.Array(Type4.String()), Type4.Null()]),
  numSources: Type4.Number(),
  hasDecoySitePost: Type4.Boolean(),
  isDeleted: Type4.Boolean()
});
var assessmentQuestion = new SchemaValidator(assessmentQuestionType);
var assessmentQuestions = new SchemaValidator(Type4.Array(assessmentQuestionType));
var questionSources = new SchemaValidator(
  Type4.Object({
    sources: Type4.Array(
      Type4.Object({
        url: Type4.String(),
        email: Type4.Union([Type4.String(), Type4.Null()])
      })
    ),
    numSources: Type4.Number()
  })
);
var assessmentTypeInput = new SchemaValidator(
  Type4.Union([Type4.Literal("canvas-new-quiz"), Type4.Literal("assignment"), Type4.Literal("canvas-quiz")])
);
var assessmentAvailability = new SchemaValidator(
  Type4.Object({
    availability: Type4.Union([Type4.Literal("available"), Type4.Literal("hidden")])
  })
);
var aiGeneratedQuestion = new SchemaValidator(
  Type4.Union([
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("MultipleChoice"),
      options: Type4.Array(mcOptionInstructor.schema)
    }),
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("TrueFalse"),
      options: Type4.Array(tfOptionInstructor.schema)
    }),
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("FillInTheBlank"),
      options: Type4.Array(fitbBlankAnswerInstructor.schema)
    }),
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("Matching"),
      options: Type4.Array(matchingPairInstructor.schema)
    }),
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("Essay"),
      options: essayOption.schema
    }),
    Type4.Object({
      questionText: Type4.String(),
      questionType: Type4.Literal("Ordering"),
      options: Type4.Array(orderingOptionInstructor.schema)
    })
  ])
);
var aiGeneratedQuestionsResponse = new SchemaValidator(
  Type4.Object({
    questions: Type4.Array(aiGeneratedQuestion.schema)
  })
);
var schema_validators_default3 = {
  assessmentInfo,
  assessmentInfoArray,
  assessmentInfoList,
  lmsAssessmentInfo,
  standaloneStudentList,
  d2lContentQuizzes,
  d2lContentPlatform,
  lmsThirdPartyQuiz,
  lmsThirdPartyQuizzes,
  lmsThirdPartyQuizWithActivityUrl,
  lmsThirdPartyQuizzesWithActivityUrl,
  verityEnabledAssessment,
  verityEnabledAssessments,
  suffixUpdateResult,
  assessmentMonthlyCountList,
  validate,
  synchronize,
  lmsPassword,
  assessmentQuestion,
  assessmentQuestions,
  aiGeneratedQuestion,
  aiGeneratedQuestionsResponse,
  questionSources,
  verityAssessment,
  instructorQuizQuestion,
  studentQuizQuestion,
  choiceAnswer,
  fitbAnswer,
  matchingAnswer,
  essayAnswer,
  orderingAnswer,
  quizQuestionSubmissionFile,
  audioRecordingAnswer,
  fileSubmissionAnswer,
  dragAndDropAnswer,
  dropdownAnswer,
  spreadsheetAnswer,
  codingLanguage,
  codingAnswer,
  quizAnswer,
  mcOption,
  mcOptionInstructor,
  tfOption,
  tfOptionInstructor,
  fitbBlankAnswer,
  fitbBlankAnswerInstructor,
  matchingPair,
  matchingPairInstructor,
  fileUploadOption,
  essayOption,
  orderingOption,
  orderingOptionInstructor,
  quizQuestionConfiguration,
  audioRecordingConfiguration,
  fileSubmissionConfiguration,
  multipleChoiceConfiguration,
  audioRecordingOption,
  fileSubmissionOption,
  codingOption,
  dragAndDropOption,
  dragAndDropOptionInstructor,
  dropdownChoice,
  dropdownChoiceInstructor,
  dropdownBlank,
  dropdownBlankInstructor,
  spreadsheetCell,
  spreadsheetCellInstructor,
  spreadsheetRow,
  spreadsheetRowInstructor,
  assessmentTypeInput,
  assessmentAvailability
};

// src/schemas/typebox/authentication/schema-validators.ts
import { Type as Type5 } from "@sinclair/typebox";
var authenticated = new SchemaValidator(
  Type5.Object({
    authenticated: Type5.Boolean()
  })
);
var accessCode = new SchemaValidator(
  Type5.Object({
    code: Type5.String()
  })
);
var accessControlAuthCode = new SchemaValidator(
  Type5.Object({
    authCode: Type5.String()
  })
);
var refreshTokenInfo = new SchemaValidator(
  Type5.Object({
    refreshToken: Type5.String(),
    accountId: Type5.String(),
    currentUserId: Type5.String()
  })
);
var accountType = Type5.Object({
  id: Type5.String(),
  email: OptionalOrNull(Type5.String()),
  currentUserId: OptionalOrNull(Type5.String()),
  userIds: Type5.Array(Type5.String()),
  twoFactorVerified: OptionalOrNull(Type5.Boolean())
});
var account = new SchemaValidator(accountType);
var accounts = new SchemaValidator(PaginatedResults(accountType, "accounts"));
var getAccountPortals = new SchemaValidator(
  Type5.Object({
    entries: Type5.Array(
      Type5.Object({
        accountId: Type5.String(),
        userId: Type5.String(),
        role: Type5.String(),
        instituteId: Type5.String(),
        instituteName: OptionalOrNull(Type5.String()),
        institutePlatform: OptionalOrNull(Type5.String()),
        instituteOrigin: OptionalOrNull(Type5.String()),
        productType: OptionalOrNull(Type5.String()),
        createdDate: OptionalOrNull(Type5.String())
      })
    )
  })
);
var getAccountInstitutes = new SchemaValidator(
  PaginatedResults(
    Type5.Object({
      hostname: OptionalOrNull(Type5.String()),
      id: Type5.String(),
      name: OptionalOrNull(Type5.String()),
      origin: OptionalOrNull(Type5.String()),
      platform: OptionalOrNull(Type5.String())
    }),
    "institutes"
  )
);
var schema_validators_default4 = {
  authenticated,
  accessCode,
  accessControlAuthCode,
  refreshTokenInfo,
  account,
  accounts,
  getAccountPortals,
  getAccountInstitutes
};

// src/schemas/typebox/basic-auth/schema-validators.ts
import { Type as Type6 } from "@sinclair/typebox";
var createAccount = new SchemaValidator(
  Type6.Object({
    id: Type6.String(),
    email: Type6.String(),
    enabled: Type6.Boolean(),
    accountNonLocked: Type6.Boolean(),
    currentUserId: OptionalOrNull(Type6.String()),
    userIds: Type6.Array(Type6.String())
  })
);
var login = new SchemaValidator(
  Type6.Union([
    Type6.Object({
      refreshToken: Type6.String(),
      accountId: Type6.String(),
      mfaRequired: Type6.Literal(false)
    }),
    Type6.Object({
      mfaChallengeToken: Type6.String(),
      mfaRequired: Type6.Literal(true),
      mfaMethod: Type6.Literal("email")
    }),
    Type6.Object({
      mfaChallengeToken: Type6.String(),
      mfaRequired: Type6.Literal(true),
      mfaMethod: Type6.Literal("totp"),
      mfaEnabled: Type6.Literal(true)
    }),
    Type6.Object({
      mfaChallengeToken: Type6.String(),
      mfaRequired: Type6.Literal(true),
      mfaMethod: Type6.Literal("totp"),
      mfaEnabled: Type6.Literal(false),
      qrCodeUrl: Type6.String(),
      twoFactorSecret: Type6.String()
    })
  ])
);
var verifyEmail = new SchemaValidator(
  Type6.Object({
    accountId: Type6.String(),
    emailVerificationToken: Type6.String()
  })
);
var resetPassword = new SchemaValidator(
  Type6.Object({
    accountId: Type6.String(),
    passwordRestToken: Type6.String(),
    password: Type6.String()
  })
);
var verifyTwoFactor = new SchemaValidator(
  Type6.Object({
    refreshToken: Type6.String(),
    accountId: Type6.String()
  })
);
var verifyTwoFactorFailure = new SchemaValidator(
  Type6.Object({
    reason: Type6.Union([Type6.Literal("INVALID_CODE"), Type6.Literal("TOO_MANY_ATTEMPTS"), Type6.Literal("EXPIRED")])
  })
);
var twoFactorStatus = new SchemaValidator(
  Type6.Object({
    twoFactorVerified: Type6.Boolean()
  })
);
var verifiedTwoFactorAccounts = new SchemaValidator(Type6.Array(Type6.String()));
var schema_validators_default5 = {
  createAccount,
  login,
  verifyEmail,
  resetPassword,
  verifyTwoFactor,
  verifyTwoFactorFailure,
  twoFactorStatus,
  verifiedTwoFactorAccounts
};

// src/schemas/typebox/course/schema-validators.ts
import { Type as Type7 } from "@sinclair/typebox";
var courseInfoType = Type7.Object({
  id: Type7.Number(),
  instituteId: Type7.Number(),
  courseId: Type7.String(),
  code: Type7.Optional(Type7.Union([Type7.String(), Type7.Null()])),
  name: Type7.Optional(Type7.Union([Type7.String(), Type7.Null()])),
  isBlackboardUltra: Type7.Optional(Type7.Union([Type7.Boolean(), Type7.Null()])),
  verityEnabled: Type7.Boolean(),
  accessControlUuid: Type7.String()
});
var courseInfo = new SchemaValidator(courseInfoType);
var courseInfoList = new SchemaValidator(Type7.Array(courseInfoType));
var accessControlCourseInfoType = Type7.Object({
  id: Type7.String(),
  instituteId: Type7.String(),
  code: OptionalOrNull(Type7.String()),
  name: OptionalOrNull(Type7.String())
});
var accessControlCourseInfo = new SchemaValidator(accessControlCourseInfoType);
var courseId = new SchemaValidator(
  Type7.Object({
    id: Type7.Number()
  })
);
var courseCount = new SchemaValidator(
  Type7.Object({
    totalElements: Type7.Number()
  })
);
var geofenceLocationType = Type7.Object({
  longitude: Type7.Number(),
  latitude: Type7.Number(),
  radius: Type7.Number(),
  name: Type7.String(),
  isMetric: Type7.Boolean()
});
var courseSettings = new SchemaValidator(
  Type7.Object({
    geofenceLocations: Type7.Array(geofenceLocationType)
  })
);
var modulesType = Type7.Object({
  id: Type7.String(),
  name: Type7.String()
});
var courseRootModules = new SchemaValidator(
  Type7.Object({
    modules: Type7.Array(modulesType)
  })
);
var module = new SchemaValidator(modulesType);
var schema_validators_default6 = {
  courseInfo,
  courseInfoList,
  accessControlCourseInfo,
  courseId,
  courseCount,
  courseSettings,
  courseRootModules,
  module
};

// src/schemas/typebox/download/schema-validators.ts
import { Type as Type8 } from "@sinclair/typebox";
var lockdownDownloadPath = new SchemaValidator(
  Type8.Object({
    path: Type8.String(),
    files: Type8.Array(
      Type8.Object({
        url: Type8.String(),
        size: Type8.Number()
      })
    )
  })
);
var requestProctoringSessionDownloadResponse = new SchemaValidator(
  Type8.Object({
    ready: Type8.Boolean(),
    emailDestination: Type8.String()
  })
);
var schema_validators_default7 = {
  lockdownDownloadPath,
  requestProctoringSessionDownloadResponse
};

// src/schemas/typebox/face-verification/schema-validators.ts
import { Type as Type9 } from "@sinclair/typebox";
var faceVerificationError = Type9.Union([
  Type9.Object({ type: Type9.Literal("phoneInId"), devices: Type9.Array(Type9.String()) }),
  Type9.Object({ type: Type9.Literal("phoneInFace"), devices: Type9.Array(Type9.String()) }),
  Type9.Object({ type: Type9.Literal("phoneDetected"), devices: Type9.Array(Type9.String()) }),
  Type9.Object({ type: Type9.Literal("noIdInId") }),
  Type9.Object({ type: Type9.Literal("manyIdInId"), count: Type9.Number() }),
  Type9.Object({ type: Type9.Literal("idInFace") }),
  Type9.Object({ type: Type9.Literal("missingFace") })
]);
var compareFacesRequest = new SchemaValidator(
  Type9.Object({
    idImage: Type9.String(),
    personImage: Type9.String()
  })
);
var compareFacesResponse = new SchemaValidator(
  Type9.Object({
    isValid: Type9.Boolean(),
    errors: Type9.Array(faceVerificationError),
    score: Type9.Number(),
    match: Type9.Boolean()
  })
);
var schema_validators_default8 = {
  compareFacesRequest,
  compareFacesResponse
};

// src/schemas/typebox/feedback/schema-validators.ts
import { Type as Type10 } from "@sinclair/typebox";
var satisfactionType = new SchemaValidator(
  Type10.Union([Type10.Literal("poor"), Type10.Literal("satisfied"), Type10.Literal("good"), Type10.Literal("excellent")])
);
var categoryType = new SchemaValidator(
  Type10.Union([Type10.Literal("suggestion"), Type10.Literal("bug"), Type10.Literal("comment"), Type10.Literal("other")])
);
var schema_validators_default9 = {
  satisfactionType,
  categoryType
};

// src/schemas/typebox/installation/schema-validators.ts
import { Type as Type11 } from "@sinclair/typebox";
var installation = new SchemaValidator(
  Type11.Object({
    id: Type11.String(),
    platform: Type11.Union([Type11.Literal("extension"), Type11.Literal("lockdown"), Type11.Literal("mobile")]),
    version: Type11.String(),
    fingerprint: Type11.String(),
    details: Type11.Object({})
  })
);
var schema_validators_default10 = {
  installation
};

// src/schemas/typebox/institute/schema-validators.ts
import { Type as Type13 } from "@sinclair/typebox";

// src/schemas/typebox/proctoring-profile/schema-validators.ts
import { Type as Type12 } from "@sinclair/typebox";
var recordingModeType2 = Type12.Union([Type12.Literal("off"), Type12.Literal("normal"), Type12.Literal("strict")]);
var proctoringOptionProfileType = Type12.Union([
  Type12.Literal("institute"),
  Type12.Literal("course"),
  Type12.Literal("user"),
  Type12.Literal("assessment"),
  Type12.Literal("preset"),
  Type12.Literal("subAccount")
]);
function OptionalOrNull2(type) {
  return Type12.Optional(Type12.Union([Type12.Null(), type]));
}
var proctoringOptionType = Type12.Object({
  enforceLockdown: Type12.Boolean(),
  enforceMobile: Type12.Boolean(),
  isExtension: Type12.Boolean(),
  isLockdown: Type12.Boolean(),
  isMobile: Type12.Boolean(),
  isChromeOs: Type12.Boolean(),
  isBrowser: Type12.Boolean(),
  videoRecordingMode: recordingModeType2,
  secondaryVideoRecordingMode: recordingModeType2,
  audioRecordingMode: recordingModeType2,
  recordScreen: Type12.Boolean(),
  recordWebTraffic: Type12.Boolean(),
  detectSidePanel: Type12.Boolean(),
  excludedWebTrafficRecordingUrls: OptionalOrNull2(Type12.Array(Type12.String())),
  recordClipboard: Type12.Boolean(),
  recordInput: Type12.Boolean(),
  oneScreenEnforcementMode: recordingModeType2,
  disableNewTab: Type12.Boolean(),
  closeOpenTabs: Type12.Boolean(),
  tabWhiteList: OptionalOrNull2(Type12.Array(Type12.String())),
  tabBlockList: OptionalOrNull2(Type12.Array(Type12.String())),
  keyboardShortcutBlockList: OptionalOrNull2(Type12.Array(Type12.String())),
  disableClipboardMode: Type12.Union([Type12.Literal("off"), Type12.Literal("tab"), Type12.Literal("system")]),
  enableGuidedAccessMode: Type12.Boolean(),
  restrictHandoffMode: recordingModeType2,
  disableSpellcheck: Type12.Boolean(),
  disablePrinting: Type12.Boolean(),
  disableRightClick: Type12.Boolean(),
  extensionBlockMode: recordingModeType2,
  allowedExtensionsList: OptionalOrNull2(Type12.Array(Type12.String())),
  logInstalledExtensions: Type12.Boolean(),
  disableDownloadFiles: Type12.Boolean(),
  hideOtherWindows: Type12.Boolean(),
  showRecordingPanel: Type12.Boolean(),
  idVerification: Type12.Boolean(),
  idVerificationEnableAi: Type12.Boolean(),
  faceTrackingMode: recordingModeType2,
  objectDetectionMode: recordingModeType2,
  applicationBlockMode: recordingModeType2,
  blockWindowedApplications: Type12.Boolean(),
  applicationBlockList: OptionalOrNull2(Type12.Array(Type12.String())),
  allowedApplicationsList: OptionalOrNull2(Type12.Array(Type12.String())),
  blockVirtualMachines: Type12.Boolean(),
  recordApplicationsActivity: Type12.Boolean(),
  logRunningApplications: Type12.Boolean(),
  scanRoom: Type12.Boolean(),
  quietEnvironment: Type12.Boolean(),
  enableCalculator: Type12.Union([Type12.Literal("off"), Type12.Literal("scientific"), Type12.Literal("standard")]),
  enableWhiteboard: Type12.Boolean(),
  enableCodeEditor: Type12.Boolean(),
  codeEditorRoomId: OptionalOrNull2(Type12.Array(Type12.String(), { maxItems: 1 })),
  uploadScratchNotes: Type12.Boolean(),
  idVerificationMode: recordingModeType2,
  restrictDevices: Type12.Boolean(),
  enableManualEndProctoring: Type12.Boolean(),
  enableReferenceMaterial: Type12.Boolean(),
  referenceMaterialMode: Type12.Union([Type12.Literal("off"), Type12.Literal("instructor"), Type12.Literal("student")]),
  audioTranscription: Type12.Boolean(),
  flaggedKeywords: Type12.Union([
    Type12.Null(),
    Type12.Array(
      Type12.Object({
        keyword: Type12.String(),
        level: Type12.Optional(Type12.Number())
      })
    )
  ]),
  uploadSignature: Type12.Boolean(),
  enableGeofence: Type12.Boolean(),
  geofenceLocations: OptionalOrNull2(
    Type12.Array(
      Type12.Object({
        longitude: Type12.Number(),
        latitude: Type12.Number(),
        radius: Type12.Number(),
        name: Type12.String(),
        isMetric: Type12.Boolean()
      })
    )
  ),
  disableVirtualCamera: Type12.Boolean(),
  enableIpAddressRestriction: Type12.Boolean(),
  allowedIpAddresses: OptionalOrNull2(
    Type12.Array(
      Type12.Object({
        min: Type12.String(),
        max: Type12.String()
      })
    )
  )
});
var proctoringOptionProfile = Type12.Object({
  id: Type12.Number(),
  name: Type12.Union([Type12.Null(), Type12.String()]),
  type: proctoringOptionProfileType,
  proctoringOption: Type12.Object({
    ...proctoringOptionType.properties
  }),
  instituteProfile: OptionalOrNull2(
    Type12.Object({
      id: Type12.Number(),
      enforced: Type12.Boolean(),
      instituteId: Type12.Number(),
      proctoringOptionProfileId: Type12.Number()
    })
  ),
  courseProfile: OptionalOrNull2(
    Type12.Object({
      id: Type12.Number(),
      courseId: Type12.Number(),
      proctoringOptionProfileId: Type12.Number()
    })
  ),
  userProfile: OptionalOrNull2(
    Type12.Object({
      id: Type12.Number(),
      userId: Type12.Number(),
      proctoringOptionProfileId: Type12.Number()
    })
  ),
  subAccountProfiles: Type12.Optional(
    Type12.Array(
      Type12.Object({
        id: Type12.Number(),
        subAccountId: Type12.Number(),
        proctoringOptionProfileId: Type12.Number()
      })
    )
  )
});
var profiles = new SchemaValidator(Type12.Array(proctoringOptionProfile));
var enforced = new SchemaValidator(Type12.Object({ enforced: Type12.Boolean() }));
var schema_validators_default11 = {
  profile: new SchemaValidator(proctoringOptionProfile),
  profileOrNull: new SchemaValidator(Type12.Union([Type12.Null(), proctoringOptionProfile])),
  profiles,
  enforced,
  proctoringOption: new SchemaValidator(proctoringOptionType)
};

// ../database/dist/prisma/gen/zod/index.js
import { z } from "zod";
var TransactionIsolationLevelSchema = z.enum(["ReadUncommitted", "ReadCommitted", "RepeatableRead", "Serializable"]);
var GlobalSettingScalarFieldEnumSchema = z.enum(["key", "value"]);
var ResourceScalarFieldEnumSchema = z.enum(["id", "name", "createdAt", "updatedAt"]);
var RoleScalarFieldEnumSchema = z.enum(["id", "name", "type", "createdAt", "updatedAt"]);
var RoleResourcePermissionScalarFieldEnumSchema = z.enum(["id", "roleId", "resourceId", "permission", "createdAt", "updatedAt"]);
var InstituteUserRoleScalarFieldEnumSchema = z.enum(["id", "instituteUserId", "roleId", "createdAt", "updatedAt"]);
var CourseUserRoleScalarFieldEnumSchema = z.enum(["id", "courseUserId", "roleId", "createdAt", "updatedAt"]);
var LmsCourseScalarFieldEnumSchema = z.enum(["id", "instituteId", "courseId", "courseInfo", "accessControlUuid", "createdAt", "updatedAt", "verityEnabled", "subAccountId"]);
var LmsCourseUserScalarFieldEnumSchema = z.enum(["id", "userId", "courseId", "viewVideos", "createdAt", "updatedAt"]);
var LmsQuizScalarFieldEnumSchema = z.enum(["id", "courseId", "quizId", "quizInfo", "other", "isDeleted", "summary", "createdAt", "updatedAt", "sourcesLastScanned", "ltiPayload"]);
var VerityAssessmentScalarFieldEnumSchema = z.enum(["quizId", "type", "isPublished", "syncGradebook", "startTime", "endTime", "allowLateSubmission", "lateSubmissionDate", "shuffleQuestions", "questionsPerPage", "numAttempts", "showScoreOnSubmit", "duration", "description", "moduleId", "scoringStrategy", "createdAt", "updatedAt"]);
var AssessmentQuestionScalarFieldEnumSchema = z.enum(["id", "assessmentId", "lmsProvidedQuestionId", "title", "bodyHtml", "bodyText", "sources", "numSources", "decoySiteHostname", "decoySitePostId", "isDeleted", "createdAt", "updatedAt"]);
var QuestionSourcesScalarFieldEnumSchema = z.enum(["id", "hostname", "email", "createdAt", "updatedAt"]);
var LmsQuizCacheScalarFieldEnumSchema = z.enum(["id", "quizId", "courseId", "platformId", "activityUrl", "createdAt", "updatedAt"]);
var LmsQuizCopyCheckedScalarFieldEnumSchema = z.enum(["id", "instituteId", "lmsCourseId", "quizId", "createdAt"]);
var Lti1p3InstituteScalarFieldEnumSchema = z.enum(["id", "instituteName", "lms", "language", "origin", "issId", "ltiClientId", "lmsApiClientId", "lmsApiClientSecret", "lmsApiIncludeD2LCorePermission", "deploymentId", "accessControlUuid", "isDisabled", "createdAt", "updatedAt", "institutionType", "accountType"]);
var InstitutePendingDeletionScalarFieldEnumSchema = z.enum(["id", "instituteId", "initiatingUserId", "initiatingUserName", "initiatingUserEmail", "deletionDate", "status", "createdAt", "updatedAt"]);
var LuminaPartnerKeyScalarFieldEnumSchema = z.enum(["id", "keyId", "keyHash", "label", "createdAt", "lastUsedAt", "revokedAt"]);
var LuminaResultsTokenScalarFieldEnumSchema = z.enum(["id", "tokenId", "instituteId", "courseId", "lmsQuizId", "studentId", "createdAt", "expiresAt", "redeemedAt"]);
var LtiDeploymentHostnameScalarFieldEnumSchema = z.enum(["id", "ltiDeploymentId", "hostname", "createdAt", "updatedAt"]);
var Lti1p3IssScalarFieldEnumSchema = z.enum(["id", "iss", "platformOidcEndpoint", "platformJwksEndpoint", "createdAt", "updatedAt"]);
var ProctoringExemptionScalarFieldEnumSchema = z.enum(["id", "assessmentId", "userId", "proctoringOptionProfileId", "accommodationNotes", "createdAt", "updatedAt"]);
var InstitutionProctoringAccommodationScalarFieldEnumSchema = z.enum(["id", "userId", "proctoringOptionProfileId", "accommodationNotes", "createdAt", "updatedAt"]);
var LmsTokenScalarFieldEnumSchema = z.enum(["id", "instituteUserId", "accessToken", "refreshToken", "exp", "createdAt", "updatedAt", "isDeleted"]);
var ProctoringOptionScalarFieldEnumSchema = z.enum(["id", "videoRecordingMode", "secondaryVideoRecordingMode", "audioRecordingMode", "recordScreen", "scanRoom", "recordWebTraffic", "detectSidePanel", "oneScreenEnforcementMode", "disableNewTab", "closeOpenTabs", "tabWhiteList", "disableClipboardMode", "enableGuidedAccessMode", "restrictHandoffMode", "showRecordingPanel", "idVerification", "idVerificationEnableAi", "faceTrackingMode", "objectDetectionMode", "enforceLockdown", "enforceMobile", "isExtension", "isLockdown", "isMobile", "isChromeOs", "isBrowser", "recordClipboard", "recordInput", "excludedWebTrafficRecordingUrls", "disableSpellcheck", "disablePrinting", "disableRightClick", "extensionBlockMode", "allowedExtensionsList", "logInstalledExtensions", "tabBlockList", "hideOtherWindows", "keyboardShortcutBlockList", "disableDownloadFiles", "applicationBlockMode", "blockWindowedApplications", "applicationBlockList", "allowedApplicationsList", "blockVirtualMachines", "recordApplicationsActivity", "logRunningApplications", "quietEnvironment", "enableCalculator", "enableWhiteboard", "enableCodeEditor", "codeEditorRoomId", "uploadScratchNotes", "idVerificationMode", "restrictDevices", "enableManualEndProctoring", "enableReferenceMaterial", "referenceMaterialMode", "audioTranscription", "flaggedKeywords", "uploadSignature", "enableGeofence", "geofenceLocations", "disableVirtualCamera", "enableIpAddressRestriction", "allowedIpAddresses", "createdAt", "updatedAt"]);
var ThirdPartyAssessmentOptionScalarFieldEnumSchema = z.enum(["id", "thirdPartyUrl", "password", "proctoringAssessmentConfigurationId", "thirdPartyPlatformId", "createdAt", "updatedAt"]);
var ProctoringAssessmentConfigurationScalarFieldEnumSchema = z.enum(["id", "lmsQuizId", "proctoringOptionProfileId", "enabled", "isLiveProctored", "isLivePopIn", "enablePostReview", "forceChromeOsManagedGuestSession", "password", "createdAt", "updatedAt"]);
var ProctoringOptionProfileScalarFieldEnumSchema = z.enum(["id", "name", "proctoringOptionId", "type", "createdAt", "updatedAt"]);
var ProctoringOptionInstituteProfileScalarFieldEnumSchema = z.enum(["id", "enforced", "instituteId", "proctoringOptionProfileId"]);
var ProctoringOptionCourseProfileScalarFieldEnumSchema = z.enum(["id", "courseId", "proctoringOptionProfileId"]);
var ProctoringOptionUserProfileScalarFieldEnumSchema = z.enum(["id", "userId", "proctoringOptionProfileId"]);
var ProctoringOptionSubAccountProfileScalarFieldEnumSchema = z.enum(["id", "proctoringOptionProfileId", "subAccountId"]);
var VerityInstituteSettingsScalarFieldEnumSchema = z.enum(["id", "instituteId", "allowLiveProctoring", "liveProctoringResetableCredits", "liveProctoringCreditsResetDate", "liveProctoringOneTimeCredits", "allowLivePopIn", "livePopInResetableCredits", "livePopInCreditsResetDate", "livePopInOneTimeCredits", "allowLivePopInPostReview", "allowAutomatedProctoring", "allowStandaloneMode", "disableProctorMode", "allowDemoMode", "allowAiStrictMode", "allowExtensionPlatform", "allowLockdownPlatform", "allowMobilePlatform", "allowBrowserPlatform", "showAllAssessments", "liteMode", "liteModeViewReports", "salesforceId", "cleanupEnabled", "cutoffDate", "cleanupFrequency", "lastCleanupAt", "allowVerityAssessment", "tier", "disabledProctoringOptions", "createdAt", "updatedAt"]);
var InstituteUsageLimitScalarFieldEnumSchema = z.enum(["id", "instituteId", "usageMode", "category", "proctorGroupId", "type", "resetableLimit", "resetDate", "oneTimeCredits", "annualType", "oneTimeCreditsType"]);
var InstituteUsageCacheScalarFieldEnumSchema = z.enum(["id", "instituteId", "category", "proctorGroupId", "type", "date", "usage"]);
var InstituteUsageUserCacheScalarFieldEnumSchema = z.enum(["id", "instituteId", "category", "proctorGroupId", "date", "studentId"]);
var LiveSessionUsageCacheScalarFieldEnumSchema = z.enum(["id", "instituteId", "proctorGroupIds", "startTime", "endTime", "hours", "sessions", "user"]);
var ProctoringSessionScalarFieldEnumSchema = z.enum(["id", "uuid", "createdAt", "updatedAt", "lmsQuizId", "studentId", "screencaptureAvailability", "webcamAvailability", "screencaptureVideos", "webcamVideos", "idPhotoAvailable", "personPhotoAvailable", "liveSessionId", "liveUserSessionId", "postReviewPending", "liveProctorSummaryPending", "usageTracked", "ipAddress", "isWebcamAndScreenCaptureDeleted", "webcamAndScreenCaptureDeleteCause", "webcamAndScreenCaptureDeleteAt", "isRoomScanDeleted", "roomScanDeleteCause", "roomScanDeleteAt", "syncedToLmsAt", "signatureType"]);
var DemoSessionScalarFieldEnumSchema = z.enum(["id", "email", "firstName", "lastName", "organization", "role", "verificationTokenHash", "verificationExpiresAt", "verifiedAt", "demoSessionTokenHash", "demoUserId", "accessControlAccountId", "principalExpiresAt", "proctoringSessionUuid", "completedAt", "resultStatus", "processingStartedAt", "processingDeadlineAt", "resultReadyAt", "resultTokenHash", "resultEmailTokenCiphertext", "resultExpiresAt", "resultEmailStatus", "resultEmailAttempts", "resultEmailLastAttemptAt", "resultEmailNextAttemptAt", "resultEmailSentAt", "cameraDisconnectSelfReportedAt", "createdAt", "updatedAt"]);
var ProctoringSessionAnomaliesScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "type", "flagLevel", "timeStart", "timeEnd", "resolved", "comment", "createdAt", "updatedAt"]);
var ProctoringSessionEventScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "type", "name", "details", "time", "endTime", "createdAt", "updatedAt", "anomalyRef"]);
var ProctoringSessionRekognitionEventScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "time", "storage"]);
var UserScalarFieldEnumSchema = z.enum(["id", "lmsProvidedUserId", "instituteId", "editInstitute", "name", "userInfo", "other", "accessControlUuid", "stripeUserId", "createdAt", "updatedAt"]);
var UserSessionScalarFieldEnumSchema = z.enum(["id", "sid", "expires", "data", "createdAt", "updatedAt", "userId"]);
var UserSecurityPinScalarFieldEnumSchema = z.enum(["userId", "pin", "createdAt", "updatedAt"]);
var UserStateScalarFieldEnumSchema = z.enum(["userId", "npsSurveyShownAt", "latestReportShownAt", "candidateWelcomeShownAt", "loginCount", "activeSetupStep", "tosAgreedAt", "createdAt", "updatedAt"]);
var YujaAccountScalarFieldEnumSchema = z.enum(["id", "username", "password", "roleId", "createdAt", "updatedAt"]);
var YujaAccountRoleScalarFieldEnumSchema = z.enum(["id", "role", "permissions", "createdAt", "updatedAt"]);
var YujaDebugInstanceScalarFieldEnumSchema = z.enum(["id", "uuid", "system", "createdAt", "updatedAt"]);
var YujaDebugStatisticScalarFieldEnumSchema = z.enum(["id", "instanceId", "userId", "userSessionId", "proctoringSessionId", "type", "time", "details", "createdAt", "updatedAt"]);
var InstallationScalarFieldEnumSchema = z.enum(["id", "platform", "version", "fingerprint", "details", "createdAt", "updatedAt"]);
var AuditLogSessionScalarFieldEnumSchema = z.enum(["id", "installationId", "userId", "fingerprint", "platform", "platformDetails", "systemDetails", "createdAt"]);
var AuditLogScalarFieldEnumSchema = z.enum(["id", "sessionId", "context", "type", "ipAddress", "proctoringSessionId", "liveSessionId", "details", "time", "createdAt"]);
var LiveSessionScalarFieldEnumSchema = z.enum(["id", "assessmentId", "liveProvidedSessionId", "status", "name", "startTime", "endTime", "capacity", "demoMode", "createdAt", "updatedAt"]);
var LiveSessionStudentScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "instituteUserId", "joined", "createdAt", "updatedAt"]);
var ProctorGroupScalarFieldEnumSchema = z.enum(["id", "name", "ownerInstituteId", "createdAt", "updatedAt"]);
var ProctorGroupAllowedInstituteScalarFieldEnumSchema = z.enum(["id", "proctorGroupId", "instituteId", "minHoursNotice", "hoursNotAcceptedNotify", "hoursTrackCancellation", "trackCancellationMessage", "createdAt", "updatedAt"]);
var ProctorGroupProctorScalarFieldEnumSchema = z.enum(["id", "userId", "proctorGroupId", "createdAt", "updatedAt"]);
var ProctorGroupAdminScalarFieldEnumSchema = z.enum(["id", "userId", "proctorGroupId", "createdAt", "updatedAt"]);
var ProctorAvailabilityScalarFieldEnumSchema = z.enum(["id", "userId", "availability", "createdAt", "updatedAt"]);
var LiveSessionProctorScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "instituteUserId", "joined", "createdAt", "updatedAt"]);
var LiveSessionProctorGroupScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "proctorGroupId", "selectedProctorId", "joined", "checkProctorAt", "createdAt", "updatedAt"]);
var LiveSessionNoteScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "studentInstituteUserId", "createdAt", "updatedAt"]);
var LiveSessionNoteEditScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "liveSessionNoteId", "editorId", "editorInstituteUserId", "content", "createdAt", "updatedAt"]);
var CancelledLiveSessionScalarFieldEnumSchema = z.enum(["id", "liveSessionId", "assessmentId", "assessmentName", "courseId", "courseName", "instituteId", "instituteName", "name", "startTime", "endTime", "capacity", "sessionCreatedAt", "sessionUpdatedAt", "cancelledAt", "recordUpdatedAt"]);
var CancelledLiveSessionProctorGroupScalarFieldEnumSchema = z.enum(["id", "cancelledLiveSessionId", "proctorGroupId", "selectedProctorId", "createdAt", "updatedAt"]);
var CourseEmailSettingsScalarFieldEnumSchema = z.enum(["id", "instituteUserId", "courseId", "createdAt", "updatedAt"]);
var CourseSettingsScalarFieldEnumSchema = z.enum(["id", "courseId", "allowStopRecording", "geofenceLocations", "createdAt", "updatedAt"]);
var ThirdPartyPlatformScalarFieldEnumSchema = z.enum(["id", "name"]);
var InstituteAndThirdPartyPlatformsScalarFieldEnumSchema = z.enum(["id", "instituteId", "platformId"]);
var InstituteSettingsScalarFieldEnumSchema = z.enum(["id", "instituteId", "allowStopRecording", "policyStatementFileName", "defaultProctoringOptionProfileId", "disabledProctoringOptions", "allowStrictMode", "suffix", "createdAt", "updatedAt", "scopeSettingsMode", "lockdownRequireManagedGuestSession", "managedGuestSessionRequireIncognito", "delayRecordingUntilAssessmentStart", "allowPortalMadeThirdPartyAssessments", "flaggedKeywords", "allowQuizAttemptOnChrome", "allowQuizAttemptOnFirefox", "allowQuizAttemptOnSafari", "recordingMaxAgeMonths", "sessionRecordingLimitHours", "proctoringRegistrationNotifications", "preferredProctoringSetupUiVersion", "dailyDigestEmailEnabled", "platformChatEnabled"]);
var UserSettingsScalarFieldEnumSchema = z.enum(["id", "instituteUserId", "language", "createdAt", "updatedAt"]);
var TemporaryAccessCodeScalarFieldEnumSchema = z.enum(["accessCode", "userId", "data", "createdAt"]);
var StandaloneStudentInfoScalarFieldEnumSchema = z.enum(["id", "userId", "accessCode", "email", "firstName", "lastName", "data", "createdAt", "expiryDate", "lmsQuizId", "accountId"]);
var LmsCourseAnomalyConfigScalarFieldEnumSchema = z.enum(["id", "lmsCourseId", "setting", "createdAt", "updatedAt"]);
var ProctoringSessionStateScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "status", "createdAt", "updatedAt"]);
var ProctoringSessionNoteScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "content", "timestamp", "createdAt", "updatedAt"]);
var ProctoringRoomScanNoteScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "content", "timestamp", "createdAt", "updatedAt"]);
var ExtensionInstallationScalarFieldEnumSchema = z.enum(["id", "instanceId", "userId", "isUpdate", "time", "details", "createdAt", "updatedAt"]);
var BlackboardAuthorizationRequestScalarFieldEnumSchema = z.enum(["id", "accountId", "refreshToken", "lmsOrigin", "redirectUri", "codeVerifier", "state", "createdDate", "expiryDate"]);
var InstituteUpdateLogScalarFieldEnumSchema = z.enum(["id", "accountId", "userId", "details", "timestamp"]);
var ApplicationsScalarFieldEnumSchema = z.enum(["id", "name", "processName", "iconSvg", "type", "createdAt", "updatedAt"]);
var ExtensionsScalarFieldEnumSchema = z.enum(["id", "extensionId", "extensionName", "iconSvg", "type", "createdAt", "updatedAt"]);
var SubAccountsScalarFieldEnumSchema = z.enum(["id", "accountName", "instituteId", "lmsAccountId", "lmsAccountUuid", "parentLmsAccountId", "rootLmsAccountId", "lmsAccountState", "verityEnabled", "createdAt", "updatedAt"]);
var ProctoringSessionReportScalarFieldEnumSchema = z.enum(["proctoringSessionId", "studentId", "studentName", "quizId", "quizName", "lmsCourseId", "instituteId", "type", "noneFlagCount", "minorFlagCount", "majorFlagCount", "severeFlagCount", "secondsProctored", "sessionStartTime", "anomalyTypeCount", "createdAt", "updatedAt"]);
var InstituteReportScalarFieldEnumSchema = z.enum(["id", "instituteId", "startDate", "endDate", "uniqueStudents", "uniqueAssessments", "totalSessions", "totalLiveSessions", "totalLiveCheckInSessions", "totalProctoringHours", "totalLiveHours", "averageIntegrityScore", "anomalyTypeCount", "courseTableData", "createdAt", "updatedAt"]);
var InstituteReportSummaryScalarFieldEnumSchema = z.enum(["id", "instituteId", "startDate", "endDate", "summary", "createdAt", "updatedAt"]);
var InstitutionReportEmailScalarFieldEnumSchema = z.enum(["id", "institutionId", "month", "year", "adminEmails", "topMetrics", "title", "summary", "isApproved", "isSent", "createdAt", "updatedAt"]);
var ExemptedInstitutionReportEmailUsersScalarFieldEnumSchema = z.enum(["id", "userId", "createdAt", "updatedAt"]);
var SubAccountReportScalarFieldEnumSchema = z.enum(["id", "subAccountId", "instituteId", "startDate", "endDate", "uniqueStudents", "uniqueAssessments", "totalSessions", "totalLiveSessions", "totalLiveCheckInSessions", "totalProctoringHours", "totalLiveHours", "averageIntegrityScore", "anomalyTypeCount", "courseTableData", "createdAt", "updatedAt"]);
var SubAccountReportSummaryScalarFieldEnumSchema = z.enum(["id", "subAccountId", "startDate", "endDate", "summary", "createdAt", "updatedAt"]);
var CourseReportScalarFieldEnumSchema = z.enum(["id", "courseId", "startDate", "endDate", "uniqueStudents", "uniqueAssessments", "totalSessions", "totalLiveSessions", "totalLiveCheckInSessions", "totalProctoringHours", "totalLiveHours", "averageIntegrityScore", "anomalyTypeCount", "assessmentTableData", "createdAt", "updatedAt"]);
var CourseReportSummaryScalarFieldEnumSchema = z.enum(["id", "courseId", "startDate", "endDate", "summary", "createdAt", "updatedAt"]);
var MoodleAccessTokenScalarFieldEnumSchema = z.enum(["id", "instituteId", "accessToken"]);
var SocketSessionScalarFieldEnumSchema = z.enum(["id", "proctoringSessionUuid", "createdAt"]);
var SocketEventScalarFieldEnumSchema = z.enum(["id", "socketSessionId", "name", "createdAt", "ackedAt"]);
var LmsTokenAuthorizationRequestScalarFieldEnumSchema = z.enum(["id", "state", "userId", "courseId", "callbackUrl", "createdAt"]);
var ScratchNoteScalarFieldEnumSchema = z.enum(["id", "proctoringSessionUuid", "mimeType", "createdAt", "uploadedAt"]);
var ApiRouteConfigScalarFieldEnumSchema = z.enum(["id", "version", "route", "instituteId", "active", "createdAt", "updatedAt"]);
var RecordingScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "recordingId", "sourceIndex", "type", "chunked", "createdAt", "updatedAt"]);
var RecordingConcatenationRequestScalarFieldEnumSchema = z.enum(["proctoringSessionId", "type", "number", "requestId", "status", "createdAt", "updatedAt"]);
var RuleScalarFieldEnumSchema = z.enum(["id", "instituteId", "scope", "scopeValue", "type", "details", "order", "enabled", "createdAt", "updatedAt"]);
var TemporaryEnabledCourseScalarFieldEnumSchema = z.enum(["id", "courseId", "instituteId"]);
var ProctoringSessionDataDumpScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "source", "mimeType", "createdAt", "uploadedAt"]);
var InstitutionPaymentOptionsScalarFieldEnumSchema = z.enum(["id", "currency", "instituteId", "automatedType", "liveProctoringType", "liveCheckInType", "livePostReviewType", "livePostReviewPrice", "liveCheckInPrice", "liveProctoringPrice", "automatedProctoringPrice", "enabled", "createdAt", "updatedAt"]);
var StripePaymentSessionScalarFieldEnumSchema = z.enum(["id", "assessmentId", "userId", "proctoringSessionId", "stripeSessionId", "paid", "claimed", "createdAt", "updatedAt"]);
var RestrictedDevicePeerScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "role", "platform", "options"]);
var RestrictedDeviceStateScalarFieldEnumSchema = z.enum(["id", "peerId", "connected", "data", "createdAt", "updatedAt"]);
var RestrictedDeviceSingleUseGrantScalarFieldEnumSchema = z.enum(["id", "peerId", "secret", "accountId", "createdAt"]);
var FeedbackScalarFieldEnumSchema = z.enum(["id", "userId", "satisfaction", "category", "summary", "details", "status", "isDeleted", "createdAt", "updatedAt"]);
var EventBannerScalarFieldEnumSchema = z.enum(["id", "createdBy", "title", "link", "buttonText", "institutions", "roles", "startDate", "endDate", "isDeleted", "createdAt", "updatedAt"]);
var InferenceTokenScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "data", "createdAt", "updatedAt"]);
var InstituteStateScalarFieldEnumSchema = z.enum(["instituteId", "lastVisualizerLaunchTime", "lastLti1p3LaunchTime", "ltiQuickLinkTemplate", "ltiQuickLinkTemplateAt", "createdAt", "updatedAt"]);
var InstituteSetupGuideScalarFieldEnumSchema = z.enum(["instituteId", "setupProfileId", "setupQuizId", "takeStepUserId", "lti1p3SetupComplete", "visualizerSetupComplete", "apiSetupComplete", "profileSetupComplete", "extensionSetupComplete", "createSetupComplete", "takeSetupComplete", "resultSetupComplete", "createdAt", "updatedAt"]);
var ProctoringSessionSummaryScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "source", "summary", "authorId", "createdAt", "updatedAt"]);
var SetupSupportChatMessageScalarFieldEnumSchema = z.enum(["id", "proctoringSessionId", "fromUser", "timestamp", "message"]);
var CandidateInterviewOptionsScalarFieldEnumSchema = z.enum(["id", "title", "candidateName", "candidateEmail", "positionName", "videoPlatform", "meetingLink", "notes", "proctoringAssessmentConfigurationId"]);
var CronExpireRecordingScalarFieldEnumSchema = z.enum(["id", "instituteId", "lastProcessedId", "startedAt", "updatedAt", "stoppedAt"]);
var QuizQuestionScalarFieldEnumSchema = z.enum(["id", "quizId", "questionText", "questionOrder", "questionType", "correctionPoints", "options", "configuration", "isDeleted", "aiGradingEnabled", "aiGradingCriteria", "createdAt", "updatedAt"]);
var QuizResponseScalarFieldEnumSchema = z.enum(["id", "sessionId", "questionSnapshot", "questionNo", "answer", "isAnswered", "createdAt", "updatedAt"]);
var QuizResponseGradeScalarFieldEnumSchema = z.enum(["id", "responseId", "score", "notes", "isDraft", "isGraded", "gradedByAi", "aiJustification", "createdAt", "updatedAt"]);
var FingerprintsScalarFieldEnumSchema = z.enum(["id", "fingerprint", "questionId", "responseId", "wordOffset", "createdAt", "updatedAt"]);
var SortOrderSchema = z.enum(["asc", "desc"]);
var JsonNullValueInputSchema = z.enum(["JsonNull"]);
var NullableJsonNullValueInputSchema = z.enum(["DbNull", "JsonNull"]);
var JsonNullValueFilterSchema = z.enum(["DbNull", "JsonNull", "AnyNull"]);
var QueryModeSchema = z.enum(["default", "insensitive"]);
var GlobalSettingOrderByRelevanceFieldEnumSchema = z.enum(["key"]);
var ResourceOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var RoleOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var NullsOrderSchema = z.enum(["first", "last"]);
var LmsCourseOrderByRelevanceFieldEnumSchema = z.enum(["courseId", "accessControlUuid"]);
var LmsQuizOrderByRelevanceFieldEnumSchema = z.enum(["quizId"]);
var VerityAssessmentOrderByRelevanceFieldEnumSchema = z.enum(["description", "moduleId"]);
var AssessmentQuestionOrderByRelevanceFieldEnumSchema = z.enum(["lmsProvidedQuestionId", "title", "bodyHtml", "bodyText", "decoySiteHostname", "decoySitePostId"]);
var QuestionSourcesOrderByRelevanceFieldEnumSchema = z.enum(["hostname", "email"]);
var LmsQuizCacheOrderByRelevanceFieldEnumSchema = z.enum(["quizId", "activityUrl"]);
var LmsQuizCopyCheckedOrderByRelevanceFieldEnumSchema = z.enum(["lmsCourseId", "quizId"]);
var Lti1p3InstituteOrderByRelevanceFieldEnumSchema = z.enum(["instituteName", "lms", "language", "origin", "ltiClientId", "lmsApiClientId", "lmsApiClientSecret", "deploymentId", "accessControlUuid"]);
var InstitutePendingDeletionOrderByRelevanceFieldEnumSchema = z.enum(["initiatingUserId", "initiatingUserName", "initiatingUserEmail"]);
var LuminaPartnerKeyOrderByRelevanceFieldEnumSchema = z.enum(["keyId", "keyHash", "label"]);
var LuminaResultsTokenOrderByRelevanceFieldEnumSchema = z.enum(["tokenId"]);
var LtiDeploymentHostnameOrderByRelevanceFieldEnumSchema = z.enum(["hostname"]);
var Lti1p3IssOrderByRelevanceFieldEnumSchema = z.enum(["iss", "platformOidcEndpoint", "platformJwksEndpoint"]);
var ProctoringExemptionOrderByRelevanceFieldEnumSchema = z.enum(["accommodationNotes"]);
var InstitutionProctoringAccommodationOrderByRelevanceFieldEnumSchema = z.enum(["accommodationNotes"]);
var LmsTokenOrderByRelevanceFieldEnumSchema = z.enum(["accessToken", "refreshToken"]);
var ThirdPartyAssessmentOptionOrderByRelevanceFieldEnumSchema = z.enum(["thirdPartyUrl", "password"]);
var ProctoringAssessmentConfigurationOrderByRelevanceFieldEnumSchema = z.enum(["password"]);
var ProctoringOptionProfileOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var VerityInstituteSettingsOrderByRelevanceFieldEnumSchema = z.enum(["salesforceId"]);
var InstituteUsageLimitOrderByRelevanceFieldEnumSchema = z.enum(["proctorGroupId"]);
var InstituteUsageCacheOrderByRelevanceFieldEnumSchema = z.enum(["proctorGroupId"]);
var InstituteUsageUserCacheOrderByRelevanceFieldEnumSchema = z.enum(["proctorGroupId"]);
var LiveSessionUsageCacheOrderByRelevanceFieldEnumSchema = z.enum(["id"]);
var ProctoringSessionOrderByRelevanceFieldEnumSchema = z.enum(["uuid", "liveSessionId", "liveUserSessionId", "ipAddress", "webcamAndScreenCaptureDeleteCause", "roomScanDeleteCause"]);
var DemoSessionOrderByRelevanceFieldEnumSchema = z.enum(["id", "email", "firstName", "lastName", "organization", "role", "verificationTokenHash", "demoSessionTokenHash", "accessControlAccountId", "proctoringSessionUuid", "resultTokenHash", "resultEmailTokenCiphertext"]);
var ProctoringSessionAnomaliesOrderByRelevanceFieldEnumSchema = z.enum(["type", "comment"]);
var ProctoringSessionEventOrderByRelevanceFieldEnumSchema = z.enum(["type", "name"]);
var UserOrderByRelevanceFieldEnumSchema = z.enum(["lmsProvidedUserId", "name", "accessControlUuid", "stripeUserId"]);
var UserSessionOrderByRelevanceFieldEnumSchema = z.enum(["sid"]);
var UserStateOrderByRelevanceFieldEnumSchema = z.enum(["activeSetupStep"]);
var YujaAccountOrderByRelevanceFieldEnumSchema = z.enum(["username", "password"]);
var YujaAccountRoleOrderByRelevanceFieldEnumSchema = z.enum(["role"]);
var YujaDebugInstanceOrderByRelevanceFieldEnumSchema = z.enum(["uuid"]);
var YujaDebugStatisticOrderByRelevanceFieldEnumSchema = z.enum(["type"]);
var InstallationOrderByRelevanceFieldEnumSchema = z.enum(["id", "version", "fingerprint"]);
var AuditLogSessionOrderByRelevanceFieldEnumSchema = z.enum(["installationId", "userId", "fingerprint"]);
var AuditLogOrderByRelevanceFieldEnumSchema = z.enum(["type", "ipAddress", "proctoringSessionId", "liveSessionId"]);
var LiveSessionOrderByRelevanceFieldEnumSchema = z.enum(["liveProvidedSessionId", "name"]);
var ProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var ProctorGroupAllowedInstituteOrderByRelevanceFieldEnumSchema = z.enum(["trackCancellationMessage"]);
var ProctorGroupProctorOrderByRelevanceFieldEnumSchema = z.enum(["userId"]);
var ProctorGroupAdminOrderByRelevanceFieldEnumSchema = z.enum(["userId"]);
var ProctorAvailabilityOrderByRelevanceFieldEnumSchema = z.enum(["userId"]);
var LiveSessionProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(["selectedProctorId"]);
var LiveSessionNoteEditOrderByRelevanceFieldEnumSchema = z.enum(["editorId", "content"]);
var CancelledLiveSessionOrderByRelevanceFieldEnumSchema = z.enum(["assessmentName", "courseName", "instituteName", "name"]);
var CancelledLiveSessionProctorGroupOrderByRelevanceFieldEnumSchema = z.enum(["selectedProctorId"]);
var ThirdPartyPlatformOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var InstituteSettingsOrderByRelevanceFieldEnumSchema = z.enum(["policyStatementFileName", "suffix"]);
var TemporaryAccessCodeOrderByRelevanceFieldEnumSchema = z.enum(["accessCode"]);
var StandaloneStudentInfoOrderByRelevanceFieldEnumSchema = z.enum(["accessCode", "email", "firstName", "lastName", "accountId"]);
var ProctoringSessionStateOrderByRelevanceFieldEnumSchema = z.enum(["status"]);
var ProctoringSessionNoteOrderByRelevanceFieldEnumSchema = z.enum(["content"]);
var ProctoringRoomScanNoteOrderByRelevanceFieldEnumSchema = z.enum(["content"]);
var BlackboardAuthorizationRequestOrderByRelevanceFieldEnumSchema = z.enum(["accountId", "refreshToken", "lmsOrigin", "redirectUri", "codeVerifier", "state"]);
var InstituteUpdateLogOrderByRelevanceFieldEnumSchema = z.enum(["accountId", "userId"]);
var ApplicationsOrderByRelevanceFieldEnumSchema = z.enum(["name", "iconSvg", "type"]);
var ExtensionsOrderByRelevanceFieldEnumSchema = z.enum(["extensionId", "extensionName", "iconSvg", "type"]);
var SubAccountsOrderByRelevanceFieldEnumSchema = z.enum(["accountName", "lmsAccountId", "lmsAccountUuid", "parentLmsAccountId", "rootLmsAccountId", "lmsAccountState"]);
var ProctoringSessionReportOrderByRelevanceFieldEnumSchema = z.enum(["studentName", "quizName"]);
var InstitutionReportEmailOrderByRelevanceFieldEnumSchema = z.enum(["title", "summary"]);
var MoodleAccessTokenOrderByRelevanceFieldEnumSchema = z.enum(["accessToken"]);
var SocketSessionOrderByRelevanceFieldEnumSchema = z.enum(["proctoringSessionUuid"]);
var SocketEventOrderByRelevanceFieldEnumSchema = z.enum(["name"]);
var LmsTokenAuthorizationRequestOrderByRelevanceFieldEnumSchema = z.enum(["state", "callbackUrl"]);
var ScratchNoteOrderByRelevanceFieldEnumSchema = z.enum(["id", "proctoringSessionUuid"]);
var ApiRouteConfigOrderByRelevanceFieldEnumSchema = z.enum(["route"]);
var RecordingOrderByRelevanceFieldEnumSchema = z.enum(["recordingId"]);
var RecordingConcatenationRequestOrderByRelevanceFieldEnumSchema = z.enum(["type", "requestId"]);
var RuleOrderByRelevanceFieldEnumSchema = z.enum(["scopeValue"]);
var TemporaryEnabledCourseOrderByRelevanceFieldEnumSchema = z.enum(["courseId"]);
var ProctoringSessionDataDumpOrderByRelevanceFieldEnumSchema = z.enum(["id", "source", "mimeType"]);
var InstitutionPaymentOptionsOrderByRelevanceFieldEnumSchema = z.enum(["currency"]);
var StripePaymentSessionOrderByRelevanceFieldEnumSchema = z.enum(["stripeSessionId"]);
var RestrictedDevicePeerOrderByRelevanceFieldEnumSchema = z.enum(["id"]);
var RestrictedDeviceStateOrderByRelevanceFieldEnumSchema = z.enum(["peerId"]);
var RestrictedDeviceSingleUseGrantOrderByRelevanceFieldEnumSchema = z.enum(["peerId", "secret", "accountId"]);
var FeedbackOrderByRelevanceFieldEnumSchema = z.enum(["summary", "details"]);
var EventBannerOrderByRelevanceFieldEnumSchema = z.enum(["title", "link", "buttonText"]);
var InferenceTokenOrderByRelevanceFieldEnumSchema = z.enum(["id", "data"]);
var InstituteStateOrderByRelevanceFieldEnumSchema = z.enum(["ltiQuickLinkTemplate"]);
var ProctoringSessionSummaryOrderByRelevanceFieldEnumSchema = z.enum(["authorId"]);
var SetupSupportChatMessageOrderByRelevanceFieldEnumSchema = z.enum(["message"]);
var CandidateInterviewOptionsOrderByRelevanceFieldEnumSchema = z.enum(["title", "candidateName", "candidateEmail", "positionName", "meetingLink", "notes"]);
var QuizQuestionOrderByRelevanceFieldEnumSchema = z.enum(["questionText", "aiGradingCriteria"]);
var QuizResponseGradeOrderByRelevanceFieldEnumSchema = z.enum(["notes", "aiJustification"]);
var FingerprintsOrderByRelevanceFieldEnumSchema = z.enum(["fingerprint"]);
var RoleTypeSchema = z.enum(["assessment", "course", "institute", "verity"]);
var PermissionSchema = z.enum(["read", "write", "deny"]);
var VerityAssessmentTypeSchema = z.enum(["quiz", "assignment"]);
var ScoringStrategySchema = z.enum(["highest", "first", "latest"]);
var InstitutionTypeSchema = z.enum(["candidate", "verity"]);
var AccountTypeSchema = z.enum(["production", "test", "trial", "demo"]);
var InstitutePendingDeletionStatusSchema = z.enum(["pendingFinanceApproval", "pendingArchitectApproval", "pendingDeletion", "deleted"]);
var RecordingModeSchema = z.enum(["off", "normal", "strict"]);
var DisableClipboardModeSchema = z.enum(["off", "tab", "system"]);
var CalculatorModeSchema = z.enum(["off", "scientific", "standard"]);
var ReferenceMaterialModeSchema = z.enum(["off", "instructor", "student"]);
var ProctoringOptionProfileTypeSchema = z.enum(["institute", "course", "user", "assessment", "preset", "subAccount"]);
var DisableProctorModeSchema = z.enum(["off", "extension", "lockdown", "mobile"]);
var CleanupFrequencySchema = z.enum(["daily", "weekly", "monthly"]);
var UsageModeSchema = z.enum(["unlimited", "limited", "metered"]);
var UsageCategorySchema = z.enum(["automated", "live", "popIn", "popInPostReview"]);
var UsageTypeSchema = z.enum(["sessions", "hours", "user"]);
var ProctoringSessionScreencaptureAvailabilitySchema = z.enum(["unavailable", "processing", "available", "error"]);
var ProctoringSessionWebcamAvailabilitySchema = z.enum(["unavailable", "processing", "available", "error"]);
var SignatureTypeSchema = z.enum(["photo", "drawn"]);
var DemoResultStatusSchema = z.enum(["pending", "processing", "ready", "upload_incomplete"]);
var DemoResultEmailStatusSchema = z.enum(["pending", "queued", "sending", "sent", "failed"]);
var ProctoringSessionEventStorageSchema = z.enum(["S3"]);
var InstallationPlatformSchema = z.enum(["extension", "lockdown", "mobile"]);
var AuditLogPlatformSchema = z.enum(["extension", "lockdown", "mobile", "web", "plugin"]);
var LiveSessionStatusSchema = z.enum(["pending", "scheduled", "creating", "created", "destroying", "destroyed", "error"]);
var ScopeSettingsTypeSchema = z.enum(["allCourses", "selectedAccounts", "selectedCourses"]);
var ProctoringSetupUiVersionSchema = z.enum(["v1", "v2"]);
var LanguageSchema = z.enum(["en", "fr"]);
var ProctoringSessionTypeSchema = z.enum(["automated", "live", "popIn"]);
var ScratchNoteMimeTypeSchema = z.enum(["jpeg", "png", "jpg"]);
var ApiVersionSchema = z.enum(["v1", "v2"]);
var RecordingTypeSchema = z.enum(["webcam", "screencapture", "merged", "roomscan"]);
var ConcatenationRequestStatusSchema = z.enum(["POSTPROCESS_STARTED", "POSTPROCESS_COMPLETE", "POSTPROCESS_FAILED"]);
var RuleScopeSchema = z.enum(["global", "lmsProvidedCourseId", "courseNamePrefix"]);
var RuleTypeSchema = z.enum(["editConfiguration"]);
var PaymentTypeSchema = z.enum(["assessment", "attempt"]);
var RestrictedDeviceRoleSchema = z.enum(["source", "sink"]);
var RestrictedDevicePlatformSchema = z.enum(["extension", "mobile", "lockdown", "browser"]);
var SatisfactionLevelSchema = z.enum(["excellent", "good", "poor", "satisfied"]);
var FeedbackCategorySchema = z.enum(["bug", "comment", "other", "suggestion"]);
var FeedbackStatusSchema = z.enum(["completed", "inProgress", "notStarted"]);
var ProctoringSessionSummarySourceSchema = z.enum(["ai", "liveProctor"]);
var VideoPlatformSchema = z.enum(["zoom", "teams", "googleMeet", "other"]);
var QuestionTypeSchema = z.enum(["MultipleChoice", "TrueFalse", "FillInTheBlank", "Matching", "FileUpload", "Essay", "Ordering", "AudioRecording", "FileSubmission", "DragAndDrop", "Dropdown", "Spreadsheet", "Coding"]);
var GlobalSettingSchema = z.object({
  key: z.string(),
  value: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10")
});
var ResourceSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RoleSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  type: RoleTypeSchema,
  createdAt: z.date(),
  updatedAt: z.date()
});
var RoleResourcePermissionSchema = z.object({
  id: z.number().int(),
  roleId: z.number().int(),
  resourceId: z.number().int(),
  permission: PermissionSchema,
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteUserRoleSchema = z.object({
  id: z.number().int(),
  instituteUserId: z.number().int(),
  roleId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CourseUserRoleSchema = z.object({
  id: z.number().int(),
  courseUserId: z.number().int(),
  roleId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LmsCourseSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  courseId: z.string(),
  courseInfo: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  accessControlUuid: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  verityEnabled: z.boolean().default(true),
  subAccountId: z.number().int().nullish()
});
var LmsCourseUserSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  courseId: z.number().int(),
  viewVideos: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LmsQuizSchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  quizId: z.string(),
  quizInfo: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  other: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  isDeleted: z.boolean(),
  summary: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  sourcesLastScanned: z.date().nullish(),
  ltiPayload: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish()
});
var VerityAssessmentSchema = z.object({
  quizId: z.number().int(),
  type: VerityAssessmentTypeSchema,
  isPublished: z.boolean(),
  syncGradebook: z.boolean().nullish(),
  startTime: z.date(),
  endTime: z.date(),
  allowLateSubmission: z.boolean(),
  lateSubmissionDate: z.date().nullish(),
  shuffleQuestions: z.boolean().nullish(),
  questionsPerPage: z.number().int().nullish(),
  numAttempts: z.number().int().default(1),
  showScoreOnSubmit: z.boolean().nullish(),
  duration: z.number().int().nullish(),
  description: z.string().nullish(),
  moduleId: z.string().nullish(),
  scoringStrategy: ScoringStrategySchema.default("first"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var AssessmentQuestionSchema = z.object({
  id: z.number().int(),
  assessmentId: z.number().int(),
  lmsProvidedQuestionId: z.string().nullish(),
  title: z.string().nullish(),
  bodyHtml: z.string().nullish(),
  bodyText: z.string().nullish(),
  sources: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  numSources: z.number().int(),
  decoySiteHostname: z.string().nullish(),
  decoySitePostId: z.string().nullish(),
  isDeleted: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var QuestionSourcesSchema = z.object({
  id: z.number().int(),
  hostname: z.string(),
  email: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LmsQuizCacheSchema = z.object({
  id: z.number().int(),
  quizId: z.string(),
  courseId: z.number().int(),
  platformId: z.number().int().nullish(),
  activityUrl: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LmsQuizCopyCheckedSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  lmsCourseId: z.string(),
  quizId: z.string(),
  createdAt: z.date()
});
var Lti1p3InstituteSchema = z.object({
  id: z.number().int(),
  instituteName: z.string().nullish(),
  lms: z.string().nullish(),
  language: z.string().nullish(),
  origin: z.string().nullish(),
  issId: z.number().int().nullish(),
  ltiClientId: z.string().nullish(),
  lmsApiClientId: z.string().nullish(),
  lmsApiClientSecret: z.string().nullish(),
  lmsApiIncludeD2LCorePermission: z.boolean().default(true),
  deploymentId: z.string().nullish(),
  accessControlUuid: z.string().nullish(),
  isDisabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date(),
  institutionType: InstitutionTypeSchema.default("verity"),
  accountType: AccountTypeSchema.default("production")
});
var InstitutePendingDeletionSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  initiatingUserId: z.string(),
  initiatingUserName: z.string(),
  initiatingUserEmail: z.string(),
  deletionDate: z.date().nullish(),
  status: InstitutePendingDeletionStatusSchema.default("pendingFinanceApproval"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LuminaPartnerKeySchema = z.object({
  id: z.number().int(),
  keyId: z.string(),
  keyHash: z.string(),
  label: z.string(),
  createdAt: z.date(),
  lastUsedAt: z.date().nullish(),
  revokedAt: z.date().nullish()
});
var LuminaResultsTokenSchema = z.object({
  id: z.number().int(),
  tokenId: z.string(),
  instituteId: z.number().int(),
  courseId: z.number().int(),
  lmsQuizId: z.number().int(),
  studentId: z.number().int(),
  createdAt: z.date(),
  expiresAt: z.date(),
  redeemedAt: z.date().nullish()
});
var LtiDeploymentHostnameSchema = z.object({
  id: z.number().int(),
  ltiDeploymentId: z.number().int(),
  hostname: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var Lti1p3IssSchema = z.object({
  id: z.number().int(),
  iss: z.string(),
  platformOidcEndpoint: z.string(),
  platformJwksEndpoint: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringExemptionSchema = z.object({
  id: z.number().int(),
  assessmentId: z.number().int(),
  userId: z.number().int(),
  proctoringOptionProfileId: z.number().int().nullish(),
  accommodationNotes: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstitutionProctoringAccommodationSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  proctoringOptionProfileId: z.number().int().nullish(),
  accommodationNotes: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LmsTokenSchema = z.object({
  id: z.number().int(),
  instituteUserId: z.number().int(),
  accessToken: z.string(),
  refreshToken: z.string(),
  exp: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date(),
  isDeleted: z.boolean()
});
var ProctoringOptionSchema = z.object({
  id: z.number().int(),
  videoRecordingMode: RecordingModeSchema.default("off"),
  secondaryVideoRecordingMode: RecordingModeSchema.default("off"),
  audioRecordingMode: RecordingModeSchema.default("off"),
  recordScreen: z.boolean().default(true),
  scanRoom: z.boolean(),
  recordWebTraffic: z.boolean(),
  detectSidePanel: z.boolean(),
  oneScreenEnforcementMode: RecordingModeSchema.default("off"),
  disableNewTab: z.boolean(),
  closeOpenTabs: z.boolean(),
  tabWhiteList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  disableClipboardMode: DisableClipboardModeSchema.default("off"),
  enableGuidedAccessMode: z.boolean(),
  restrictHandoffMode: RecordingModeSchema.default("off"),
  showRecordingPanel: z.boolean().default(true),
  idVerification: z.boolean(),
  idVerificationEnableAi: z.boolean(),
  faceTrackingMode: RecordingModeSchema.default("off"),
  objectDetectionMode: RecordingModeSchema.default("off"),
  enforceLockdown: z.boolean(),
  enforceMobile: z.boolean(),
  isExtension: z.boolean(),
  isLockdown: z.boolean(),
  isMobile: z.boolean(),
  isChromeOs: z.boolean(),
  isBrowser: z.boolean(),
  recordClipboard: z.boolean(),
  recordInput: z.boolean(),
  excludedWebTrafficRecordingUrls: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  disableSpellcheck: z.boolean(),
  disablePrinting: z.boolean(),
  disableRightClick: z.boolean(),
  extensionBlockMode: RecordingModeSchema.default("off"),
  allowedExtensionsList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  logInstalledExtensions: z.boolean(),
  tabBlockList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  hideOtherWindows: z.boolean().default(true),
  keyboardShortcutBlockList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  disableDownloadFiles: z.boolean(),
  applicationBlockMode: RecordingModeSchema.default("off"),
  blockWindowedApplications: z.boolean(),
  applicationBlockList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  allowedApplicationsList: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  blockVirtualMachines: z.boolean(),
  recordApplicationsActivity: z.boolean(),
  logRunningApplications: z.boolean(),
  quietEnvironment: z.boolean(),
  enableCalculator: CalculatorModeSchema.default("off"),
  enableWhiteboard: z.boolean(),
  enableCodeEditor: z.boolean(),
  codeEditorRoomId: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  uploadScratchNotes: z.boolean(),
  idVerificationMode: RecordingModeSchema.default("off"),
  restrictDevices: z.boolean(),
  enableManualEndProctoring: z.boolean(),
  enableReferenceMaterial: z.boolean(),
  referenceMaterialMode: ReferenceMaterialModeSchema.default("off"),
  audioTranscription: z.boolean(),
  flaggedKeywords: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").default("null"),
  uploadSignature: z.boolean(),
  enableGeofence: z.boolean(),
  geofenceLocations: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  disableVirtualCamera: z.boolean(),
  enableIpAddressRestriction: z.boolean(),
  allowedIpAddresses: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ThirdPartyAssessmentOptionSchema = z.object({
  id: z.number().int(),
  thirdPartyUrl: z.string().nullish(),
  password: z.string().nullish(),
  proctoringAssessmentConfigurationId: z.number().int(),
  thirdPartyPlatformId: z.number().int().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringAssessmentConfigurationSchema = z.object({
  id: z.number().int(),
  lmsQuizId: z.number().int(),
  proctoringOptionProfileId: z.number().int(),
  enabled: z.boolean(),
  isLiveProctored: z.boolean(),
  isLivePopIn: z.boolean(),
  enablePostReview: z.boolean(),
  forceChromeOsManagedGuestSession: z.boolean(),
  password: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringOptionProfileSchema = z.object({
  id: z.number().int(),
  name: z.string().nullish(),
  proctoringOptionId: z.number().int(),
  type: ProctoringOptionProfileTypeSchema,
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringOptionInstituteProfileSchema = z.object({
  id: z.number().int(),
  enforced: z.boolean(),
  instituteId: z.number().int(),
  proctoringOptionProfileId: z.number().int()
});
var ProctoringOptionCourseProfileSchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  proctoringOptionProfileId: z.number().int()
});
var ProctoringOptionUserProfileSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  proctoringOptionProfileId: z.number().int()
});
var ProctoringOptionSubAccountProfileSchema = z.object({
  id: z.number().int(),
  proctoringOptionProfileId: z.number().int(),
  subAccountId: z.number().int()
});
var VerityInstituteSettingsSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  allowLiveProctoring: z.boolean(),
  liveProctoringResetableCredits: z.number().int().nullish(),
  liveProctoringCreditsResetDate: z.date().nullish(),
  liveProctoringOneTimeCredits: z.number(),
  allowLivePopIn: z.boolean(),
  livePopInResetableCredits: z.number().int().nullish(),
  livePopInCreditsResetDate: z.date().nullish(),
  livePopInOneTimeCredits: z.number(),
  allowLivePopInPostReview: z.boolean(),
  allowAutomatedProctoring: z.boolean().default(true),
  allowStandaloneMode: z.boolean(),
  disableProctorMode: DisableProctorModeSchema.default("off"),
  allowDemoMode: z.boolean(),
  allowAiStrictMode: z.boolean(),
  allowExtensionPlatform: z.boolean().default(true),
  allowLockdownPlatform: z.boolean().default(true),
  allowMobilePlatform: z.boolean(),
  allowBrowserPlatform: z.boolean(),
  showAllAssessments: z.boolean().default(true),
  liteMode: z.boolean(),
  liteModeViewReports: z.boolean(),
  salesforceId: z.string().nullish(),
  cleanupEnabled: z.boolean(),
  cutoffDate: z.date().nullish(),
  cleanupFrequency: CleanupFrequencySchema.nullish(),
  lastCleanupAt: z.date().nullish(),
  allowVerityAssessment: z.boolean().default(true),
  tier: z.number().int().default(1),
  disabledProctoringOptions: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteUsageLimitSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  usageMode: UsageModeSchema.default("unlimited"),
  category: UsageCategorySchema,
  proctorGroupId: z.string(),
  type: UsageTypeSchema,
  resetableLimit: z.number().int(),
  resetDate: z.date(),
  oneTimeCredits: z.number(),
  annualType: UsageTypeSchema,
  oneTimeCreditsType: UsageTypeSchema
});
var InstituteUsageCacheSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  category: UsageCategorySchema,
  proctorGroupId: z.string(),
  type: UsageTypeSchema,
  date: z.date(),
  usage: z.number()
});
var InstituteUsageUserCacheSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  category: UsageCategorySchema,
  proctorGroupId: z.string(),
  date: z.date(),
  studentId: z.number().int()
});
var LiveSessionUsageCacheSchema = z.object({
  id: z.string(),
  instituteId: z.number().int(),
  proctorGroupIds: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").default("[]"),
  startTime: z.date(),
  endTime: z.date(),
  hours: z.number(),
  sessions: z.number(),
  user: z.number()
});
var ProctoringSessionSchema = z.object({
  id: z.number().int(),
  uuid: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
  lmsQuizId: z.number().int(),
  studentId: z.number().int(),
  screencaptureAvailability: ProctoringSessionScreencaptureAvailabilitySchema.default("unavailable"),
  webcamAvailability: ProctoringSessionWebcamAvailabilitySchema.default("unavailable"),
  screencaptureVideos: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  webcamVideos: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  idPhotoAvailable: z.boolean(),
  personPhotoAvailable: z.boolean(),
  liveSessionId: z.string().nullish(),
  liveUserSessionId: z.string().nullish(),
  postReviewPending: z.boolean(),
  liveProctorSummaryPending: z.boolean(),
  usageTracked: z.boolean(),
  ipAddress: z.string().nullish(),
  isWebcamAndScreenCaptureDeleted: z.boolean(),
  webcamAndScreenCaptureDeleteCause: z.string().nullish(),
  webcamAndScreenCaptureDeleteAt: z.date().nullish(),
  isRoomScanDeleted: z.boolean(),
  roomScanDeleteCause: z.string().nullish(),
  roomScanDeleteAt: z.date().nullish(),
  syncedToLmsAt: z.date().nullish(),
  signatureType: SignatureTypeSchema.nullish()
});
var DemoSessionSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  organization: z.string(),
  role: z.string(),
  verificationTokenHash: z.string(),
  verificationExpiresAt: z.date(),
  verifiedAt: z.date().nullish(),
  demoSessionTokenHash: z.string().nullish(),
  demoUserId: z.number().int().nullish(),
  accessControlAccountId: z.string().nullish(),
  principalExpiresAt: z.date().nullish(),
  proctoringSessionUuid: z.string().nullish(),
  completedAt: z.date().nullish(),
  resultStatus: DemoResultStatusSchema.default("pending"),
  processingStartedAt: z.date().nullish(),
  processingDeadlineAt: z.date().nullish(),
  resultReadyAt: z.date().nullish(),
  resultTokenHash: z.string().nullish(),
  resultEmailTokenCiphertext: z.string().nullish(),
  resultExpiresAt: z.date().nullish(),
  resultEmailStatus: DemoResultEmailStatusSchema.default("pending"),
  resultEmailAttempts: z.number().int(),
  resultEmailLastAttemptAt: z.date().nullish(),
  resultEmailNextAttemptAt: z.date().nullish(),
  resultEmailSentAt: z.date().nullish(),
  cameraDisconnectSelfReportedAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionAnomaliesSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  type: z.string(),
  flagLevel: z.number().int(),
  timeStart: z.date().nullish(),
  timeEnd: z.date().nullish(),
  resolved: z.boolean(),
  comment: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionEventSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  type: z.string(),
  name: z.string(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  time: z.date(),
  endTime: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  anomalyRef: z.number().int().nullish()
});
var ProctoringSessionRekognitionEventSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  time: z.date(),
  storage: ProctoringSessionEventStorageSchema
});
var UserSchema = z.object({
  id: z.number().int(),
  lmsProvidedUserId: z.string(),
  instituteId: z.number().int(),
  editInstitute: z.boolean(),
  name: z.string().nullish(),
  userInfo: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  other: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  accessControlUuid: z.string().nullish(),
  stripeUserId: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var UserSessionSchema = z.object({
  id: z.number().int(),
  sid: z.string(),
  expires: z.date().nullish(),
  data: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  userId: z.number().int().nullish()
});
var UserSecurityPinSchema = z.object({
  userId: z.number().int(),
  pin: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var UserStateSchema = z.object({
  userId: z.number().int(),
  npsSurveyShownAt: z.date().nullish(),
  latestReportShownAt: z.date().nullish(),
  candidateWelcomeShownAt: z.date().nullish(),
  loginCount: z.number().int(),
  activeSetupStep: z.string().nullish(),
  tosAgreedAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var YujaAccountSchema = z.object({
  id: z.number().int(),
  username: z.string(),
  password: z.string(),
  roleId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var YujaAccountRoleSchema = z.object({
  id: z.number().int(),
  role: z.string(),
  permissions: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var YujaDebugInstanceSchema = z.object({
  id: z.number().int(),
  uuid: z.string(),
  system: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var YujaDebugStatisticSchema = z.object({
  id: z.number().int(),
  instanceId: z.number().int(),
  userId: z.number().int().nullish(),
  userSessionId: z.number().int().nullish(),
  proctoringSessionId: z.number().int().nullish(),
  type: z.string(),
  time: z.date(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstallationSchema = z.object({
  id: z.string(),
  platform: InstallationPlatformSchema,
  version: z.string(),
  fingerprint: z.string(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var AuditLogSessionSchema = z.object({
  id: z.number().int(),
  installationId: z.string().nullish(),
  userId: z.string().nullish(),
  fingerprint: z.string().nullish(),
  platform: AuditLogPlatformSchema,
  platformDetails: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  systemDetails: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date()
});
var AuditLogSchema = z.object({
  id: z.number().int(),
  sessionId: z.number().int(),
  context: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  type: z.string(),
  ipAddress: z.string().nullish(),
  proctoringSessionId: z.string().nullish(),
  liveSessionId: z.string().nullish(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  time: z.date(),
  createdAt: z.date()
});
var LiveSessionSchema = z.object({
  id: z.number().int(),
  assessmentId: z.number().int(),
  liveProvidedSessionId: z.string().nullish(),
  status: LiveSessionStatusSchema.default("scheduled"),
  name: z.string(),
  startTime: z.date(),
  endTime: z.date(),
  capacity: z.number().int().default(50),
  demoMode: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LiveSessionStudentSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  instituteUserId: z.number().int(),
  joined: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctorGroupSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  ownerInstituteId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctorGroupAllowedInstituteSchema = z.object({
  id: z.number().int(),
  proctorGroupId: z.number().int(),
  instituteId: z.number().int(),
  minHoursNotice: z.number().int().default(36),
  hoursNotAcceptedNotify: z.number().int().default(24),
  hoursTrackCancellation: z.number().int(),
  trackCancellationMessage: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctorGroupProctorSchema = z.object({
  id: z.number().int(),
  userId: z.string(),
  proctorGroupId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctorGroupAdminSchema = z.object({
  id: z.number().int(),
  userId: z.string(),
  proctorGroupId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctorAvailabilitySchema = z.object({
  id: z.number().int(),
  userId: z.string(),
  availability: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LiveSessionProctorSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  instituteUserId: z.number().int(),
  joined: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LiveSessionProctorGroupSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  proctorGroupId: z.number().int(),
  selectedProctorId: z.string().nullish(),
  joined: z.boolean(),
  checkProctorAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LiveSessionNoteSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  studentInstituteUserId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var LiveSessionNoteEditSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  liveSessionNoteId: z.number().int(),
  editorId: z.string(),
  editorInstituteUserId: z.number().int().nullish(),
  content: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CancelledLiveSessionSchema = z.object({
  id: z.number().int(),
  liveSessionId: z.number().int(),
  assessmentId: z.number().int(),
  assessmentName: z.string().nullish(),
  courseId: z.number().int(),
  courseName: z.string().nullish(),
  instituteId: z.number().int(),
  instituteName: z.string().nullish(),
  name: z.string(),
  startTime: z.date(),
  endTime: z.date(),
  capacity: z.number().int().default(50),
  sessionCreatedAt: z.date(),
  sessionUpdatedAt: z.date(),
  cancelledAt: z.date(),
  recordUpdatedAt: z.date()
});
var CancelledLiveSessionProctorGroupSchema = z.object({
  id: z.number().int(),
  cancelledLiveSessionId: z.number().int(),
  proctorGroupId: z.number().int(),
  selectedProctorId: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CourseEmailSettingsSchema = z.object({
  id: z.number().int(),
  instituteUserId: z.number().int(),
  courseId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CourseSettingsSchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  allowStopRecording: z.boolean().default(true),
  geofenceLocations: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ThirdPartyPlatformSchema = z.object({
  id: z.number().int(),
  name: z.string()
});
var InstituteAndThirdPartyPlatformsSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  platformId: z.number().int()
});
var InstituteSettingsSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  allowStopRecording: z.boolean().default(true),
  policyStatementFileName: z.string().nullish(),
  defaultProctoringOptionProfileId: z.number().int().nullish(),
  disabledProctoringOptions: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  allowStrictMode: z.boolean().default(true),
  suffix: z.string().default("YuJa Verity Test Proctoring").nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
  scopeSettingsMode: ScopeSettingsTypeSchema.default("allCourses"),
  lockdownRequireManagedGuestSession: z.boolean(),
  managedGuestSessionRequireIncognito: z.boolean().default(true),
  delayRecordingUntilAssessmentStart: z.boolean(),
  allowPortalMadeThirdPartyAssessments: z.boolean(),
  flaggedKeywords: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").default("null"),
  allowQuizAttemptOnChrome: z.boolean().default(true),
  allowQuizAttemptOnFirefox: z.boolean(),
  allowQuizAttemptOnSafari: z.boolean(),
  recordingMaxAgeMonths: z.number().int().default(12),
  sessionRecordingLimitHours: z.number().int().default(12).nullish(),
  proctoringRegistrationNotifications: z.boolean().default(true),
  preferredProctoringSetupUiVersion: ProctoringSetupUiVersionSchema.default("v2"),
  dailyDigestEmailEnabled: z.boolean().default(true),
  platformChatEnabled: z.boolean()
});
var UserSettingsSchema = z.object({
  id: z.number().int(),
  instituteUserId: z.number().int(),
  language: LanguageSchema.nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var TemporaryAccessCodeSchema = z.object({
  accessCode: z.string(),
  userId: z.number().int(),
  data: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date()
});
var StandaloneStudentInfoSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  accessCode: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  data: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  expiryDate: z.date(),
  lmsQuizId: z.number().int(),
  accountId: z.string().nullish()
});
var LmsCourseAnomalyConfigSchema = z.object({
  id: z.number().int(),
  lmsCourseId: z.number().int(),
  setting: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionStateSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  status: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionNoteSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  content: z.string(),
  timestamp: z.date(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringRoomScanNoteSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  content: z.string(),
  timestamp: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ExtensionInstallationSchema = z.object({
  id: z.number().int(),
  instanceId: z.number().int(),
  userId: z.number().int().nullish(),
  isUpdate: z.boolean(),
  time: z.date(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var BlackboardAuthorizationRequestSchema = z.object({
  id: z.number().int(),
  accountId: z.string(),
  refreshToken: z.string(),
  lmsOrigin: z.string(),
  redirectUri: z.string(),
  codeVerifier: z.string(),
  state: z.string(),
  createdDate: z.date(),
  expiryDate: z.date()
});
var InstituteUpdateLogSchema = z.object({
  id: z.number().int(),
  accountId: z.string().nullish(),
  userId: z.string().nullish(),
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  timestamp: z.date()
});
var ApplicationsSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  processName: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  iconSvg: z.string(),
  type: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ExtensionsSchema = z.object({
  id: z.number().int(),
  extensionId: z.string(),
  extensionName: z.string(),
  iconSvg: z.string(),
  type: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var SubAccountsSchema = z.object({
  id: z.number().int(),
  accountName: z.string(),
  instituteId: z.number().int(),
  lmsAccountId: z.string(),
  lmsAccountUuid: z.string().nullish(),
  parentLmsAccountId: z.string().nullish(),
  rootLmsAccountId: z.string().nullish(),
  lmsAccountState: z.string().nullish(),
  verityEnabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionReportSchema = z.object({
  proctoringSessionId: z.number().int(),
  studentId: z.number().int(),
  studentName: z.string().nullish(),
  quizId: z.number().int(),
  quizName: z.string().nullish(),
  lmsCourseId: z.number().int(),
  instituteId: z.number().int(),
  type: ProctoringSessionTypeSchema,
  noneFlagCount: z.number().int(),
  minorFlagCount: z.number().int(),
  majorFlagCount: z.number().int(),
  severeFlagCount: z.number().int(),
  secondsProctored: z.number().int(),
  sessionStartTime: z.date(),
  anomalyTypeCount: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteReportSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  uniqueStudents: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  uniqueAssessments: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  totalSessions: z.number().int(),
  totalLiveSessions: z.number().int(),
  totalLiveCheckInSessions: z.number().int(),
  totalProctoringHours: z.number(),
  totalLiveHours: z.number(),
  averageIntegrityScore: z.number().nullish(),
  anomalyTypeCount: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  courseTableData: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteReportSummarySchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  summary: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstitutionReportEmailSchema = z.object({
  id: z.number().int(),
  institutionId: z.number().int(),
  month: z.number().int(),
  year: z.number().int(),
  adminEmails: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  topMetrics: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  title: z.string(),
  summary: z.string(),
  isApproved: z.boolean(),
  isSent: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ExemptedInstitutionReportEmailUsersSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var SubAccountReportSchema = z.object({
  id: z.number().int(),
  subAccountId: z.number().int(),
  instituteId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  uniqueStudents: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  uniqueAssessments: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  totalSessions: z.number().int(),
  totalLiveSessions: z.number().int(),
  totalLiveCheckInSessions: z.number().int(),
  totalProctoringHours: z.number(),
  totalLiveHours: z.number(),
  averageIntegrityScore: z.number().nullish(),
  anomalyTypeCount: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  courseTableData: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var SubAccountReportSummarySchema = z.object({
  id: z.number().int(),
  subAccountId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  summary: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CourseReportSchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  uniqueStudents: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  uniqueAssessments: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  totalSessions: z.number().int(),
  totalLiveSessions: z.number().int(),
  totalLiveCheckInSessions: z.number().int(),
  totalProctoringHours: z.number(),
  totalLiveHours: z.number(),
  averageIntegrityScore: z.number().nullish(),
  anomalyTypeCount: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  assessmentTableData: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var CourseReportSummarySchema = z.object({
  id: z.number().int(),
  courseId: z.number().int(),
  startDate: z.date(),
  endDate: z.date(),
  summary: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var MoodleAccessTokenSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  accessToken: z.string()
});
var SocketSessionSchema = z.object({
  id: z.number().int(),
  proctoringSessionUuid: z.string(),
  createdAt: z.date()
});
var SocketEventSchema = z.object({
  id: z.number().int(),
  socketSessionId: z.number().int(),
  name: z.string(),
  createdAt: z.date(),
  ackedAt: z.date().nullish()
});
var LmsTokenAuthorizationRequestSchema = z.object({
  id: z.number().int(),
  state: z.string(),
  userId: z.number().int(),
  courseId: z.number().int(),
  callbackUrl: z.string(),
  createdAt: z.date()
});
var ScratchNoteSchema = z.object({
  id: z.string(),
  proctoringSessionUuid: z.string(),
  mimeType: ScratchNoteMimeTypeSchema,
  createdAt: z.date(),
  uploadedAt: z.date().nullish()
});
var ApiRouteConfigSchema = z.object({
  id: z.number().int(),
  version: ApiVersionSchema,
  route: z.string(),
  instituteId: z.number().int(),
  active: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RecordingSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  recordingId: z.string(),
  sourceIndex: z.number().int(),
  type: RecordingTypeSchema,
  chunked: z.boolean().default(true),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RecordingConcatenationRequestSchema = z.object({
  proctoringSessionId: z.number().int(),
  type: z.string(),
  number: z.number().int(),
  requestId: z.string(),
  status: ConcatenationRequestStatusSchema.default("POSTPROCESS_STARTED"),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RuleSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  scope: RuleScopeSchema,
  scopeValue: z.string().nullish(),
  type: RuleTypeSchema,
  details: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  order: z.number().int(),
  enabled: z.boolean().default(true),
  createdAt: z.date(),
  updatedAt: z.date()
});
var TemporaryEnabledCourseSchema = z.object({
  id: z.number().int(),
  courseId: z.string(),
  instituteId: z.number().int()
});
var ProctoringSessionDataDumpSchema = z.object({
  id: z.string(),
  proctoringSessionId: z.number().int(),
  source: z.string(),
  mimeType: z.string(),
  createdAt: z.date(),
  uploadedAt: z.date().nullish()
});
var InstitutionPaymentOptionsSchema = z.object({
  id: z.number().int(),
  currency: z.string(),
  instituteId: z.number().int(),
  automatedType: PaymentTypeSchema.default("assessment"),
  liveProctoringType: PaymentTypeSchema.default("assessment"),
  liveCheckInType: PaymentTypeSchema.default("assessment"),
  livePostReviewType: PaymentTypeSchema.default("assessment"),
  livePostReviewPrice: z.number(),
  liveCheckInPrice: z.number(),
  liveProctoringPrice: z.number(),
  automatedProctoringPrice: z.number(),
  enabled: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var StripePaymentSessionSchema = z.object({
  id: z.number().int(),
  assessmentId: z.number().int(),
  userId: z.number().int(),
  proctoringSessionId: z.number().int().nullish(),
  stripeSessionId: z.string(),
  paid: z.boolean(),
  claimed: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RestrictedDevicePeerSchema = z.object({
  id: z.string(),
  proctoringSessionId: z.number().int(),
  role: RestrictedDeviceRoleSchema,
  platform: RestrictedDevicePlatformSchema,
  options: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish()
});
var RestrictedDeviceStateSchema = z.object({
  id: z.number().int(),
  peerId: z.string(),
  connected: z.boolean(),
  data: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var RestrictedDeviceSingleUseGrantSchema = z.object({
  id: z.number().int(),
  peerId: z.string(),
  secret: z.string(),
  accountId: z.string().nullish(),
  createdAt: z.date()
});
var FeedbackSchema = z.object({
  id: z.number().int(),
  userId: z.number().int(),
  satisfaction: SatisfactionLevelSchema,
  category: FeedbackCategorySchema,
  summary: z.string(),
  details: z.string(),
  status: FeedbackStatusSchema.default("notStarted"),
  isDeleted: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var EventBannerSchema = z.object({
  id: z.number().int(),
  createdBy: z.number().int(),
  title: z.string(),
  link: z.string(),
  buttonText: z.string(),
  institutions: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  roles: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  startDate: z.date(),
  endDate: z.date(),
  isDeleted: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InferenceTokenSchema = z.object({
  id: z.string(),
  proctoringSessionId: z.number().int(),
  data: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteStateSchema = z.object({
  instituteId: z.number().int(),
  lastVisualizerLaunchTime: z.date().nullish(),
  lastLti1p3LaunchTime: z.date().nullish(),
  ltiQuickLinkTemplate: z.string().nullish(),
  ltiQuickLinkTemplateAt: z.date().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var InstituteSetupGuideSchema = z.object({
  instituteId: z.number().int(),
  setupProfileId: z.number().int().nullish(),
  setupQuizId: z.number().int().nullish(),
  takeStepUserId: z.number().int().nullish(),
  lti1p3SetupComplete: z.boolean(),
  visualizerSetupComplete: z.boolean(),
  apiSetupComplete: z.boolean(),
  profileSetupComplete: z.boolean(),
  extensionSetupComplete: z.boolean(),
  createSetupComplete: z.boolean(),
  takeSetupComplete: z.boolean(),
  resultSetupComplete: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var ProctoringSessionSummarySchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  source: ProctoringSessionSummarySourceSchema.default("ai"),
  summary: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  authorId: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var SetupSupportChatMessageSchema = z.object({
  id: z.number().int(),
  proctoringSessionId: z.number().int(),
  fromUser: z.boolean(),
  timestamp: z.date(),
  message: z.string()
});
var CandidateInterviewOptionsSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  candidateName: z.string(),
  candidateEmail: z.string(),
  positionName: z.string(),
  videoPlatform: VideoPlatformSchema,
  meetingLink: z.string(),
  notes: z.string().nullish(),
  proctoringAssessmentConfigurationId: z.number().int()
});
var CronExpireRecordingSchema = z.object({
  id: z.number().int(),
  instituteId: z.number().int(),
  lastProcessedId: z.number().int(),
  startedAt: z.date(),
  updatedAt: z.date(),
  stoppedAt: z.date().nullish()
});
var QuizQuestionSchema = z.object({
  id: z.number().int(),
  quizId: z.number().int(),
  questionText: z.string(),
  questionOrder: z.number().int(),
  questionType: QuestionTypeSchema,
  correctionPoints: z.number(),
  options: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  configuration: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  isDeleted: z.boolean(),
  aiGradingEnabled: z.boolean(),
  aiGradingCriteria: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var QuizResponseSchema = z.object({
  id: z.number().int(),
  sessionId: z.number().int(),
  questionSnapshot: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10"),
  questionNo: z.number().int(),
  answer: z.unknown().refine((val) => {
    const getDepth = (obj, depth = 0) => {
      if (depth > 10)
        return depth;
      if (obj === null || typeof obj !== "object")
        return depth;
      const values = Object.values(obj);
      if (values.length === 0)
        return depth;
      return Math.max(...values.map((v) => getDepth(v, depth + 1)));
    };
    return getDepth(val) <= 10;
  }, "JSON nesting depth exceeds maximum of 10").nullish(),
  isAnswered: z.boolean(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var QuizResponseGradeSchema = z.object({
  id: z.number().int(),
  responseId: z.number().int(),
  score: z.number(),
  notes: z.string().nullish(),
  isDraft: z.boolean().default(true),
  isGraded: z.boolean().default(true),
  gradedByAi: z.boolean(),
  aiJustification: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var FingerprintsSchema = z.object({
  id: z.number().int(),
  fingerprint: z.string(),
  questionId: z.number().int(),
  responseId: z.number().int(),
  wordOffset: z.number().int(),
  createdAt: z.date(),
  updatedAt: z.date()
});

// src/schemas/typebox/institute/schema-validators.ts
var accessControlInstituteId = new SchemaValidator(Type13.String());
var instituteInfo = new SchemaValidator(
  Type13.Object({
    id: Type13.Integer(),
    uuid: Type13.String(),
    name: Type13.String(),
    origin: OptionalOrNull(Type13.String()),
    lms: OptionalOrNull(Type13.String()),
    accountType: Type13.Union(AccountTypeSchema.options.map((type) => Type13.Literal(type))),
    institutionType: Type13.Union(InstitutionTypeSchema.options.map((type) => Type13.Literal(type)))
  })
);
var instituteLanguage = new SchemaValidator(
  Type13.Object({
    language: Type13.String()
  })
);
var disabledProctoringOptionType = Type13.Array(Type13.String());
var instituteDisabledProctoringOptions = new SchemaValidator(disabledProctoringOptionType);
var CleanupFrequencyTypeBoxSchema = Type13.Union(CleanupFrequencySchema.options.map((freq) => Type13.Literal(freq)));
var verityInstituteSettings = new SchemaValidator(
  Type13.Object({
    allowAutomatedProctoring: Type13.Boolean(),
    allowLiveProctoring: Type13.Boolean(),
    liveProctoringResetableCredits: OptionalOrNull(Type13.Number()),
    liveProctoringCreditsResetDate: OptionalOrNull(Type13.String()),
    liveProctoringOneTimeCredits: Type13.Number(),
    allowLivePopIn: Type13.Boolean(),
    livePopInResetableCredits: OptionalOrNull(Type13.Number()),
    livePopInCreditsResetDate: OptionalOrNull(Type13.String()),
    livePopInOneTimeCredits: Type13.Number(),
    allowLivePopInPostReview: Type13.Boolean(),
    allowStandaloneMode: Type13.Boolean(),
    allowAiStrictMode: Type13.Boolean(),
    allowDemoMode: Type13.Boolean(),
    allowExtensionPlatform: Type13.Boolean(),
    allowLockdownPlatform: Type13.Boolean(),
    allowMobilePlatform: Type13.Boolean(),
    allowBrowserPlatform: Type13.Boolean(),
    showAllAssessments: Type13.Boolean(),
    liteMode: Type13.Boolean(),
    liteModeViewReports: Type13.Boolean(),
    salesforceId: OptionalOrNull(Type13.String()),
    cleanupEnabled: Type13.Boolean(),
    cutoffDate: OptionalOrNull(Type13.String()),
    cleanupFrequency: OptionalOrNull(CleanupFrequencyTypeBoxSchema),
    lastCleanupAt: OptionalOrNull(Type13.String()),
    allowVerityAssessment: Type13.Boolean(),
    tier: Type13.Number(),
    disabledProctoringOptions: OptionalOrNull(disabledProctoringOptionType)
  })
);
var integrated = new SchemaValidator(
  Type13.Object({
    integrated: Type13.Boolean()
  })
);
var hostnameRegistered = new SchemaValidator(
  Type13.Object({
    registered: Type13.Boolean()
  })
);
var CourseSettings = new SchemaValidator(
  Type13.Object({
    "CourseSetting-allowStopRecording": Type13.Boolean(),
    "InstituteSetting-allowStopRecording": Type13.Boolean(),
    "CourseEmailSetting-courseEmailSetting": Type13.Boolean()
  })
);
var instituteAllowStrictMode = new SchemaValidator(
  Type13.Object({
    allowStrictMode: Type13.Boolean(),
    allowAiStrictMode: Type13.Boolean()
  })
);
var lmsAccounts = new SchemaValidator(
  Type13.Array(
    Type13.Object({
      id: Type13.Integer(),
      accountName: Type13.String(),
      lmsAccountId: Type13.String(),
      parentLmsAccountId: OptionalOrNull(Type13.String()),
      rootLmsAccountId: OptionalOrNull(Type13.String()),
      lmsAccountState: OptionalOrNull(Type13.String()),
      verityEnabled: Type13.Boolean()
    })
  )
);
var instituteScopeMode = new SchemaValidator(
  Type13.Object({
    scopeMode: Type13.Union([
      Type13.Literal("allCourses"),
      Type13.Literal("selectedAccounts"),
      Type13.Literal("selectedCourses")
    ]),
    allAccounts: Type13.Array(
      Type13.Object({
        id: Type13.Integer(),
        accountName: Type13.String(),
        lmsAccountId: Type13.String(),
        parentLmsAccountId: OptionalOrNull(Type13.String()),
        verityEnabled: Type13.Boolean()
      })
    ),
    selectedCourses: Type13.Array(
      Type13.Object({
        id: Type13.Integer(),
        courseId: Type13.String(),
        courseName: Type13.String(),
        courseUrl: Type13.String()
      })
    )
  })
);
var instituteSuffix = new SchemaValidator(
  Type13.Object({
    suffix: Type13.Union([Type13.String(), Type13.Null()])
  })
);
var latestReport = new SchemaValidator(
  Type13.Object(
    {
      month: Type13.Number(),
      year: Type13.Number(),
      title: Type13.String(),
      summary: Type13.String(),
      topMetrics: Type13.Array(
        Type13.Object({
          key: Type13.String(),
          type: Type13.Optional(Type13.String()),
          currentValue: Type13.String(),
          previousValue: Type13.Optional(Type13.String()),
          percentChange: Type13.Optional(Type13.String()),
          imageUrl: Type13.Optional(Type13.String()),
          texts: Type13.Array(Type13.String())
        })
      )
    },
    { additionalProperties: true }
  )
);
var proctoringOptionKey = new SchemaValidator(Type13.KeyOf(proctoringOptionProfile.properties.proctoringOption));
var instituteId = new SchemaValidator(
  Type13.Object({
    id: Type13.Number()
  })
);
var accessControlInstitute = new SchemaValidator(
  Type13.Object({
    id: Type13.String(),
    name: OptionalOrNull(Type13.String()),
    origin: OptionalOrNull(Type13.String()),
    platform: OptionalOrNull(Type13.String()),
    subdomain: OptionalOrNull(Type13.String()),
    hostnames: Type13.Array(Type13.String()),
    product: OptionalOrNull(Type13.Union([Type13.Literal("candidate"), Type13.Literal("verity")])),
    mfaRequiredAdmin: OptionalOrNull(Type13.Boolean()),
    mfaRequiredNonAdmin: OptionalOrNull(Type13.Boolean()),
    mfaEmailFallback: OptionalOrNull(Type13.Boolean())
  })
);
var apiKey = new SchemaValidator(
  Type13.Object({
    id: Type13.Number(),
    keyId: OptionalOrNull(Type13.String()),
    platform: OptionalOrNull(Type13.String()),
    origin: OptionalOrNull(Type13.String()),
    apiUrl: OptionalOrNull(Type13.String())
  })
);
var thirdPartyPlatformRoster = new SchemaValidator(
  Type13.Object({
    selectedPlatforms: Type13.Array(
      Type13.Object({
        platformId: Type13.Number(),
        platformName: Type13.String()
      })
    ),
    unselectedPlatforms: Type13.Array(
      Type13.Object({
        platformId: Type13.Number(),
        platformName: Type13.String()
      })
    )
  })
);
var verityEnabled = new SchemaValidator(
  Type13.Object({
    verityEnabled: Type13.Boolean()
  })
);
var apiKeys = new SchemaValidator(Type13.Object({ apiKeys: Type13.Array(apiKey.schema) }));
var hostnames = new SchemaValidator(Type13.Object({ hostnames: Type13.Array(Type13.String()) }));
var thirdPartyIntegrations = new SchemaValidator(thirdPartyPlatformRoster.schema);
var instituteProctoringAccommodation = new SchemaValidator(
  Type13.Array(
    Type13.Object({
      userId: Type13.Integer(),
      accommodationNotes: OptionalOrNull(Type13.String()),
      proctoringOptionProfileId: OptionalOrNull(Type13.Integer())
    })
  )
);
var ruleType = Type13.Intersect([
  Type13.Union([
    Type13.Object({
      scope: Type13.Literal("global")
    }),
    Type13.Object({
      scope: Type13.Literal("lmsProvidedCourseId"),
      scopeValue: Type13.String()
    }),
    Type13.Object({
      scope: Type13.Literal("courseNamePrefix"),
      scopeValue: Type13.String()
    })
  ]),
  Type13.Object({
    type: Type13.Literal("editConfiguration"),
    details: OptionalOrNull(Type13.Unknown()),
    enabled: Type13.Boolean()
  })
]);
var rulesResponse = new SchemaValidator(Type13.Array(ruleType));
var instituteSettings = new SchemaValidator(
  Type13.Object({
    suffix: OptionalOrNull(Type13.String()),
    allowStrictMode: Type13.Boolean(),
    lockdownRequireManagedGuestSession: Type13.Boolean(),
    managedGuestSessionRequireIncognito: Type13.Boolean(),
    delayRecordingUntilAssessmentStart: Type13.Boolean(),
    flaggedKeywords: Type13.Union([
      Type13.Null(),
      Type13.Array(
        Type13.Object({
          keyword: Type13.String(),
          level: Type13.Optional(Type13.Number())
        })
      )
    ]),
    allowQuizAttemptOnChrome: Type13.Boolean(),
    allowQuizAttemptOnFirefox: Type13.Boolean(),
    allowQuizAttemptOnSafari: Type13.Boolean(),
    disabledProctoringOptions: Type13.Union([Type13.Null(), disabledProctoringOptionType]),
    recordingMaxAgeMonths: Type13.Integer(),
    sessionRecordingLimitHours: Type13.Union([Type13.Integer({ minimum: 1, maximum: 12 }), Type13.Null()]),
    proctoringRegistrationNotifications: Type13.Boolean(),
    allowPortalMadeThirdPartyAssessments: Type13.Boolean(),
    preferredProctoringSetupUiVersion: Type13.String(),
    platformChatEnabled: Type13.Boolean()
  })
);
var agreementUrl = new SchemaValidator(
  Type13.Object({
    url: Type13.Optional(Type13.String())
  })
);
var platformChatSettings = new SchemaValidator(
  Type13.Object({
    platformChatEnabled: Type13.Boolean()
  })
);
var schema_validators_default12 = {
  accessControlInstituteId,
  instituteInfo,
  verityInstituteSettings,
  integrated,
  hostnameRegistered,
  CourseSettings,
  instituteLanguage,
  instituteDisabledProctoringOptions,
  instituteAllowStrictMode,
  instituteScopeMode,
  lmsAccounts,
  instituteSuffix,
  latestReport,
  proctoringOptionKey,
  instituteId,
  accessControlInstitute,
  apiKey,
  apiKeys,
  verityEnabled,
  hostnames,
  thirdPartyIntegrations,
  instituteProctoringAccommodation,
  rulesResponse,
  instituteSettings,
  agreementUrl,
  platformChatSettings
};

// src/schemas/typebox/integration/schema-validators.ts
import { Type as Type14 } from "@sinclair/typebox";
var integrationStatus = new SchemaValidator(
  Type14.Object({
    active: Type14.Boolean()
  })
);
var schema_validators_default13 = {
  integrationStatus
};

// src/schemas/typebox/live/schema-validators.ts
import { Type as Type15 } from "@sinclair/typebox";
var liveSession = new SchemaValidator(
  Type15.Object({
    liveSessionId: Type15.String()
  })
);
var dayAvailability = Type15.Array(Type15.Boolean());
var availability = Type15.Object({
  type: Type15.String(),
  schedule: Type15.Array(dayAvailability)
});
var userAvailabilityResponse = new SchemaValidator(
  Type15.Object({
    userId: Type15.String(),
    availability: Type15.Array(availability)
  })
);
var proctorGroup = Type15.Object({
  id: Type15.Number(),
  name: Type15.String(),
  ownerInstituteId: Type15.String(),
  createdAt: Type15.String(),
  updatedAt: Type15.String(),
  allowedInstitutes: Type15.Array(
    Type15.Object({
      instituteId: Type15.String(),
      minHoursNotice: Type15.Number(),
      trackCancellationHoursBefore: Type15.Number(),
      trackCancellationMessage: Type15.String(),
      autoCancelEmptyHoursBefore: OptionalOrNull(Type15.Number())
    })
  ),
  emailAdminsAfterMinutesInactive: OptionalOrNull(Type15.Number()),
  inactiveEmailIntervalMinutes: OptionalOrNull(Type15.Number()),
  maxInactiveEmailCount: OptionalOrNull(Type15.Number())
});
var liveSessionUser = Type15.Object({
  liveSessionId: Type15.String(),
  userId: Type15.String(),
  role: Type15.Union([Type15.Literal("proctor"), Type15.Literal("student")]),
  createdAt: Type15.String(),
  updatedAt: Type15.String()
});
var liveSessionUserValidator = new SchemaValidator(liveSessionUser);
var liveSessionUserSession = Type15.Object({
  id: Type15.String(),
  userId: Type15.String(),
  liveSessionId: Type15.String(),
  role: Type15.Union([Type15.Literal("proctor"), Type15.Literal("student")]),
  connectionState: Type15.Union([
    Type15.Literal("connecting"),
    Type15.Literal("connected"),
    Type15.Literal("reconnecting"),
    Type15.Literal("failed")
  ])
});
var liveSessionUserSessionValidator = new SchemaValidator(liveSessionUserSession);
var liveSessionInvitation = Type15.Object({
  liveSessionId: Type15.String(),
  proctorGroupId: Type15.Number(),
  state: Type15.Object({
    selectedProctorId: OptionalOrNull(Type15.String()),
    firstJoinedAt: OptionalOrNull(Type15.String()),
    cancelledAt: OptionalOrNull(Type15.String())
  }),
  createdAt: Type15.String(),
  updatedAt: Type15.String()
});
var liveSessionInvitations = new SchemaValidator(Type15.Array(liveSessionInvitation));
var liveSessionNote = Type15.Object({
  id: Type15.String(),
  liveSessionId: Type15.String(),
  student: Type15.String(),
  edits: Type15.Array(
    Type15.Object({
      id: Type15.String(),
      editor: Type15.String(),
      content: Type15.String(),
      timestamp: Type15.Number()
    })
  )
});
var liveSessionNotes = new SchemaValidator(Type15.Array(liveSessionNote));
var assessmentLiveSession = {
  id: Type15.String(),
  instituteId: OptionalOrNull(Type15.String()),
  courseId: OptionalOrNull(Type15.String()),
  assessmentId: OptionalOrNull(Type15.String()),
  name: Type15.String(),
  isPopIn: Type15.Boolean(),
  startTime: Type15.String(),
  proctorGuide: OptionalOrNull(Type15.String()),
  endTime: Type15.String(),
  capacity: Type15.Number(),
  registrationStartTime: OptionalOrNull(Type15.String()),
  registrationEndTime: OptionalOrNull(Type15.String()),
  createdAt: Type15.String(),
  updatedAt: Type15.String()
};
var liveSessionWithUsers = Type15.Object({
  ...assessmentLiveSession,
  users: Type15.Array(liveSessionUser)
});
var baseAssessmentLiveSession = new SchemaValidator(Type15.Object(assessmentLiveSession));
var singleLiveSession = new SchemaValidator(liveSessionWithUsers);
var liveSessionList = new SchemaValidator(PaginatedResults(Type15.Object(assessmentLiveSession)));
var liveSessionListWithUsers = new SchemaValidator(PaginatedResults(liveSessionWithUsers));
var courseLiveProctorInfo = new SchemaValidator(
  Type15.Array(
    Type15.Object({
      id: Type15.Number(),
      uuid: Type15.String(),
      name: Type15.String(),
      email: OptionalOrNull(Type15.String())
    })
  )
);
var instituteProctorGroups = new SchemaValidator(PaginatedResults(proctorGroup));
var registerLiveSessionInstituteUser = new SchemaValidator(liveSessionUser);
var deregisterLiveSessionInstituteUser = new SchemaValidator(liveSessionUser);
var registerLiveSessionProctorGroup = new SchemaValidator(OptionalOrNull(liveSessionInvitation));
var deregisterLiveSessionProctorGroup = new SchemaValidator(liveSessionInvitation);
var liveSessionInvitationValidator = new SchemaValidator(liveSessionInvitation);
var liveSessionLiveState = new SchemaValidator(
  Type15.Object({
    id: Type15.String(),
    userSessionIds: Type15.Array(Type15.String())
  })
);
var liveProctorGroup = new SchemaValidator(proctorGroup);
var liveProctorGroups = new SchemaValidator(Type15.Array(proctorGroup));
var schema_validators_default14 = {
  liveSession,
  singleLiveSession,
  liveSessionUser: liveSessionUserValidator,
  liveSessionUserSession: liveSessionUserSessionValidator,
  liveSessionInvitation: liveSessionInvitationValidator,
  liveSessionList,
  liveSessionListWithUsers,
  liveSessionInvitations,
  courseLiveProctorInfo,
  instituteProctorGroups,
  liveSessionNotes,
  baseAssessmentLiveSession,
  registerLiveSessionInstituteUser,
  deregisterLiveSessionInstituteUser,
  registerLiveSessionProctorGroup,
  deregisterLiveSessionProctorGroup,
  liveSessionLiveState,
  liveProctorGroup,
  liveProctorGroups,
  userAvailabilityResponse
};

// src/schemas/typebox/lms-info/schema-validators.ts
import { Type as Type16 } from "@sinclair/typebox";
var lms = new SchemaValidator(
  Type16.Union([
    Type16.Literal("canvas"),
    Type16.Literal("moodle"),
    Type16.Literal("BlackboardLearn"),
    Type16.Literal("desire2learn")
  ])
);
var assessmentInfo2 = new SchemaValidator(
  Type16.Object({
    lms: Type16.Optional(lms.schema),
    hostname: Type16.Optional(Type16.String()),
    courseId: Type16.Optional(Type16.String()),
    quizId: Type16.String(),
    quizInfo: Type16.Optional(Type16.Record(Type16.String(), Type16.Any())),
    quizOther: Type16.Optional(Type16.Record(Type16.String(), Type16.Any()))
  })
);
var deleteAssessmentInfo = new SchemaValidator(
  Type16.Object({
    id: Type16.Number(),
    courseId: Type16.Number(),
    quizId: Type16.String(),
    quizInfo: Type16.Optional(Type16.Record(Type16.String(), Type16.Any())),
    other: Type16.Optional(Type16.Record(Type16.String(), Type16.Any())),
    isDeleted: Type16.Boolean(),
    createdAt: Type16.String(),
    updatedAt: Type16.String()
  })
);
var assessmentInfoAlternate = new SchemaValidator(
  Type16.Object({
    lms: lms.schema,
    hostname: Type16.String(),
    lmsProvidedCourseId: Type16.Optional(Type16.String()),
    lmsProvidedAssessmentId: Type16.String()
  })
);
var url = new SchemaValidator(Type16.String());
var instituteLmsInfo = new SchemaValidator(
  Type16.Object({
    id: Type16.Number(),
    instituteName: Type16.Union([Type16.Null(), Type16.String()]),
    origin: Type16.Optional(Type16.Union([Type16.Null(), Type16.String()])),
    lmsApiClientId: Type16.Optional(Type16.Union([Type16.Null(), Type16.String()])),
    lmsApiIncludeD2LCorePermission: Type16.Optional(Type16.Boolean())
  })
);
var tokenExists = new SchemaValidator(
  Type16.Object({
    exists: Type16.Boolean()
  })
);
var tokenTestResults = new SchemaValidator(
  Type16.Array(
    Type16.Object({
      key: Type16.String(),
      relativePath: Type16.String(),
      requestType: Type16.String(),
      status: Type16.String()
    })
  )
);
var deleteResponse = new SchemaValidator(
  Type16.Object({
    success: Type16.Boolean(),
    lmsResponse: Type16.Optional(Type16.Unknown())
  })
);
var apiIntegrationInfo = new SchemaValidator(
  Type16.Object({
    course: OptionalOrNull(
      Type16.Object({
        edit: Type16.Boolean()
      })
    ),
    institute: OptionalOrNull(
      Type16.Object({
        edit: Type16.Boolean()
      })
    )
  })
);
var courseContentItem = Type16.Object({
  id: Type16.Union([Type16.Number(), Type16.String()]),
  name: Type16.String(),
  lmsUrl: Type16.Optional(Type16.String()),
  downloadUrl: Type16.String(),
  size: Type16.Number()
});
var courseContentModule = Type16.Object({
  id: Type16.Number(),
  name: Type16.String(),
  items: Type16.Array(courseContentItem)
});
var courseContent = new SchemaValidator(Type16.Array(courseContentModule));
var schema_validators_default15 = {
  lms,
  assessmentInfo: assessmentInfo2,
  url,
  instituteLmsInfo,
  tokenExists,
  tokenTestResults,
  deleteResponse,
  assessmentInfoAlternate,
  deleteAssessmentInfo,
  apiIntegrationInfo,
  courseContent
};

// src/schemas/typebox/lti/schema-validators.ts
import { Type as Type17 } from "@sinclair/typebox";
var clientRegistrationType = Type17.Object({
  id: Type17.Integer(),
  linkageAttribute: OptionalOrNull(Type17.String()),
  linkUsersByEmail: Type17.Boolean()
});
var clientRegistration2 = new SchemaValidator(clientRegistrationType);
var clientRegistrations = new SchemaValidator(PaginatedResults(clientRegistrationType, "clientRegistrations"));
var schema_validators_default16 = {
  clientRegistration: clientRegistration2,
  clientRegistrations
};

// src/schemas/typebox/lumina/schema-validators.ts
import { Type as Type18 } from "@sinclair/typebox";
var LUMINA_MAX_LIVE_SESSIONS = 100;
var luminaLiveSessionType = Type18.Object(
  {
    // The diff key on republish. Matching is on this and nothing else — falling back to name or start
    // time would read an edited session as a new one, and every republish would duplicate the schedule.
    identifier: Type18.String({ minLength: 1, maxLength: 64 }),
    name: Type18.String({ minLength: 1, maxLength: 255 }),
    // ISO strings, never `Date`. The payload is structured-cloned through postMessage and then held by
    // Lumina, so only the string form survives the round trip. The schema pins the type alone; ordering
    // and window rules are checked at publish, where the error can name the offending session.
    startTime: Type18.String({ minLength: 1 }),
    endTime: Type18.String({ minLength: 1 }),
    // Required but nullable rather than optional: "no registration window" has to be stated, so a key
    // dropped somewhere in the round trip fails validation instead of quietly reading as cleared.
    registrationStartTime: Type18.Union([Type18.String({ minLength: 1 }), Type18.Null()]),
    registrationEndTime: Type18.Union([Type18.String({ minLength: 1 }), Type18.Null()]),
    capacity: Type18.Union([Type18.Integer(), Type18.Null()]),
    proctorGroupId: Type18.Union([Type18.Integer(), Type18.Null()]),
    // Rich text from the wizard's editor, unbounded here on purpose: the only ceiling that exists is
    // verity-live's own 2 MB body limit, and restating a smaller one would refuse a guide it accepts.
    proctorGuide: Type18.Union([Type18.String(), Type18.Null()])
  },
  { additionalProperties: false }
);
var luminaOptionsPayloadType = Type18.Object(
  {
    // `proctoringOptionType` itself allows unknown keys, and the save path cannot: an unrecognised key
    // reaches `updateProctoringOption`, which passes every entry it is given straight to Prisma
    // (`dal/prisma/proctoring-configuration.ts:44-49`), so it would fail as a 500 rather than a 400.
    option: Type18.Object({ ...proctoringOptionType.properties }, { additionalProperties: false }),
    configuration: Type18.Object(
      {
        isLiveProctored: Type18.Boolean(),
        isLivePopIn: Type18.Boolean(),
        enablePostReview: Type18.Boolean(),
        forceChromeOsManagedGuestSession: Type18.Boolean()
      },
      { additionalProperties: false }
    ),
    // Optional, and it must stay optional: every payload Lumina already holds predates this key, so
    // requiring it would fail validation on the next republish of every existing quiz.
    liveSessions: Type18.Optional(Type18.Array(luminaLiveSessionType, { maxItems: LUMINA_MAX_LIVE_SESSIONS })),
    // The uuid folder the configure surface uploaded instructor reference material to, which the publish
    // copies onto the assessment. Optional for the same reason as `liveSessions`, and the three states
    // are all distinct: absent means a client that predates the key and leaves the bound files alone,
    // `null` means "this quiz has no reference material" and deletes them, and a key replaces them.
    //
    // Charset and length only. The uuid shape is checked at publish, where the message can say so.
    referenceMaterialKey: Type18.Optional(Type18.Union([Type18.String({ minLength: 1, maxLength: 64 }), Type18.Null()]))
  },
  { additionalProperties: false }
);
var luminaOptionsPayload = new SchemaValidator(luminaOptionsPayloadType);

// src/schemas/typebox/media/schema-validators.ts
import { Type as Type19 } from "@sinclair/typebox";
var getNextRecordingNumbers = new SchemaValidator(
  Type19.Object({
    screencapture: Type19.Number(),
    webcam: Type19.Number()
  })
);
var uploadRecording = new SchemaValidator(
  Type19.Object({
    url: Type19.String()
  })
);
var schema_validators_default17 = {
  getNextRecordingNumbers,
  uploadRecording
};

// src/schemas/typebox/oauth/schema-validators.ts
import { Type as Type20 } from "@sinclair/typebox";
var authorization = new SchemaValidator(
  Type20.Object({
    authorizationUrl: Type20.String()
  })
);
var accessToken = new SchemaValidator(
  Type20.Object({
    accessToken: Type20.String(),
    expiresIn: Type20.Number()
  })
);
var schema_validators_default18 = {
  authorization,
  accessToken
};

// src/schemas/typebox/payment/schema-validators.ts
var schema_validators_default19 = {};

// src/schemas/typebox/permission/schema-validators.ts
import { Type as Type21 } from "@sinclair/typebox";
var verityResultPermission = new SchemaValidator(
  Type21.Object({
    verified: Type21.Boolean()
  })
);
var portalPermission = new SchemaValidator(
  Type21.Array(
    Type21.Union([
      Type21.Literal("InstituteEdit"),
      Type21.Literal("CourseEdit"),
      Type21.Literal("CourseSettingsEdit"),
      Type21.Literal("VeritySettingsEdit"),
      Type21.Literal("CourseView"),
      Type21.Literal("LiveProctoringPrivilege"),
      Type21.Literal("LiveProctoring")
    ])
  )
);
var assessmentPermissions = new SchemaValidator(
  Type21.Object({
    assessment: Type21.Array(Type21.Union([Type21.Literal("create"), Type21.Literal("update"), Type21.Literal("read")]))
  })
);
var scopedPrivileges = new SchemaValidator(
  Type21.Record(
    Type21.String(),
    Type21.Array(
      Type21.Object({
        courseId: OptionalOrNull(Type21.String()),
        instituteId: OptionalOrNull(Type21.String()),
        resourceId: OptionalOrNull(Type21.Unknown())
      })
    )
  )
);
var schema_validators_default20 = {
  verityResultPermission,
  portalPermission,
  assessmentPermissions,
  scopedPrivileges
};

// src/schemas/typebox/platform-info/schema-validators.ts
import { Type as Type22 } from "@sinclair/typebox";
var platformInfo = new SchemaValidator(
  Type22.Object({
    platform: Type22.Union([
      Type22.Literal("none"),
      Type22.Literal("lockdown"),
      Type22.Literal("extension"),
      Type22.Literal("mobile"),
      Type22.Literal("browser")
    ]),
    version: OptionalOrNull(Type22.String()),
    versionSupported: Type22.Boolean()
  })
);
var versionSupported = new SchemaValidator(
  Type22.Object({
    versionSupported: Type22.Boolean()
  })
);
var schema_validators_default21 = {
  platformInfo,
  versionSupported
};

// src/schemas/typebox/proctoring-configuration/schema-validators.ts
import { Type as Type23 } from "@sinclair/typebox";
function OptionalOrNull3(type) {
  return Type23.Optional(Type23.Union([Type23.Null(), type]));
}
var proctoringAssessmentConfigurationType = Type23.Object({
  enabled: Type23.Boolean(),
  isLiveProctored: Type23.Boolean(),
  isLivePopIn: Type23.Boolean(),
  enablePostReview: Type23.Boolean(),
  password: Type23.Union([Type23.Null(), Type23.String()]),
  forceChromeOsManagedGuestSession: OptionalOrNull3(Type23.Boolean()),
  thirdPartyAssessmentOption: OptionalOrNull3(
    Type23.Object({
      thirdPartyUrl: OptionalOrNull3(Type23.String()),
      password: OptionalOrNull3(Type23.String()),
      thirdPartyPlatformId: OptionalOrNull3(Type23.Number())
    })
  ),
  proctoringOptionProfile
});
var proctoringAssessmentConfigurationV2 = new SchemaValidator(
  Type23.Intersect([
    proctoringAssessmentConfigurationType,
    Type23.Object({
      candidateInterviewOptions: OptionalOrNull3(candidateInterviewOptionsSaveType)
    })
  ])
);
var proctoringAssessmentConfigurationV2OrNull = new SchemaValidator(
  Type23.Union([
    Type23.Null(),
    Type23.Intersect([
      proctoringAssessmentConfigurationType,
      Type23.Object({
        candidateInterviewOptions: OptionalOrNull3(candidateInterviewOptionsGetType)
      })
    ])
  ])
);
var proctoringAssessmentConfigurationResponse = new SchemaValidator(
  Type23.Object({
    standaloneStudentInfo: OptionalOrNull3(
      Type23.Array(
        Type23.Object({
          id: Type23.Number(),
          userId: Type23.Number(),
          email: Type23.String(),
          firstName: Type23.String(),
          lastName: Type23.String()
        })
      )
    ),
    verityAssessmentInfo: OptionalOrNull3(schema_validators_default3.verityAssessment.schema),
    assessmentConfiguration: OptionalOrNull3(
      Type23.Object({
        id: Type23.Number(),
        lmsQuiz: OptionalOrNull3(schema_validators_default3.assessmentInfo.schema)
      })
    )
  })
);
var enabledOptionsResponse = new SchemaValidator(
  Type23.Object({
    proctoringMethod: Type23.Array(
      Type23.Union([
        Type23.Literal("automated"),
        Type23.Literal("live"),
        Type23.Literal("pop-in"),
        Type23.Literal("pop-in-post-review")
      ])
    )
  })
);
var assessmentResourceUploadUrlResponse = new SchemaValidator(
  Type23.Object({
    uploadUrl: Type23.String()
  })
);
var fileTypeSchema = new SchemaValidator(
  Type23.Object({
    name: Type23.String(),
    url: Type23.String(),
    size: Type23.Number(),
    expiresAt: Type23.Number()
  })
);
var getAssessmentResourcesResponse = new SchemaValidator(Type23.Array(fileTypeSchema.schema));
var schema_validators_default22 = {
  proctoringAssessmentConfigurationV2,
  proctoringAssessmentConfigurationV2OrNull,
  proctoringAssessmentConfigurationResponse,
  enabledOptionsResponse,
  assessmentResourceUploadUrlResponse,
  getAssessmentResourcesResponse,
  fileTypeSchema
};

// src/schemas/typebox/proctoring-session/schema-validators.ts
import { Type as Type24 } from "@sinclair/typebox";
function StringLiteralUnion(values) {
  const literals = values.map((value) => Type24.Literal(value));
  return Type24.Union(literals);
}
var startProctoring = new SchemaValidator(
  Type24.Object({
    sessionId: Type24.String(),
    proctoringOptions: schema_validators_default2.verityOptions.schema
  })
);
var recordingBlobInfo = new SchemaValidator(
  Type24.Object({
    proctoringSessionId: Type24.String(),
    recordingType: Type24.Union([Type24.Literal("display"), Type24.Literal("webcam")]),
    recordingNumber: Type24.Number(),
    blobNumber: Type24.Number()
  })
);
var uploadS3Url = new SchemaValidator(
  Type24.Object({
    url: Type24.String()
  })
);
var lmsContext = new SchemaValidator(
  Type24.Object({
    institute: Type24.Object({
      id: Type24.Number(),
      origin: OptionalOrNull(Type24.String()),
      accessControlUuid: Type24.String()
    }),
    course: Type24.Object({
      id: Type24.Number(),
      courseId: Type24.String(),
      accessControlUuid: Type24.String()
    }),
    assessment: Type24.Object({
      id: Type24.Number(),
      quizId: Type24.String()
    })
  })
);
var mediaAvailability = StringLiteralUnion(["unavailable", "processing", "available", "error"]);
var sessionStatus = StringLiteralUnion(["unflagged", "flagged", "incomplete", "pending", "error", "unavailable"]);
var videoAvailabilityList = Type24.Object({
  available: Type24.Array(Type24.Union([Type24.Number(), Type24.String(), Type24.Null()])),
  processing: Type24.Array(Type24.Union([Type24.Number(), Type24.String(), Type24.Null()]))
  // error: Type.Array(Type.Number()),
});
var userInfo = Type24.Object({
  username: OptionalOrNull(Type24.String()),
  full_name: OptionalOrNull(Type24.String()),
  given_name: OptionalOrNull(Type24.String()),
  family_name: OptionalOrNull(Type24.String()),
  email: OptionalOrNull(Type24.String()),
  profile_picture: OptionalOrNull(Type24.String())
});
var signatureType = Type24.Union([Type24.Literal("drawn"), Type24.Literal("photo"), Type24.Null()]);
var testResults = new SchemaValidator(
  Type24.Array(
    Type24.Object({
      id: Type24.Number(),
      studentId: Type24.Number(),
      lmsQuizId: Type24.Number(),
      uuid: Type24.String(),
      screencaptureAvailability: mediaAvailability,
      webcamAvailability: mediaAvailability,
      screencaptureVideos: OptionalOrNull(videoAvailabilityList),
      webcamVideos: OptionalOrNull(videoAvailabilityList),
      idPhotoAvailable: Type24.Boolean(),
      personPhotoAvailable: Type24.Boolean(),
      userInfo: OptionalOrNull(userInfo),
      startTime: OptionalOrNull(Type24.String()),
      endTime: OptionalOrNull(Type24.String()),
      status: OptionalOrNull(sessionStatus),
      lmsQuizName: OptionalOrNull(Type24.String()),
      createdAt: OptionalOrNull(Type24.String()),
      realQuizId: OptionalOrNull(Type24.String()),
      lmsUserId: OptionalOrNull(Type24.String()),
      flagLevel: OptionalOrNull(Type24.Number()),
      hasNotes: Type24.Boolean(),
      hasRoomScanNotes: Type24.Boolean(),
      isRoomScanDeleted: Type24.Boolean(),
      roomScanDeleteCause: OptionalOrNull(Type24.String()),
      roomScanDeleteAt: OptionalOrNull(Type24.String()),
      isWebcamAndScreenCaptureDeleted: Type24.Boolean(),
      webcamAndScreenCaptureDeleteCause: OptionalOrNull(Type24.String()),
      webcamAndScreenCaptureDeleteAt: OptionalOrNull(Type24.String()),
      signatureType,
      liveSessionId: OptionalOrNull(Type24.String()),
      liveUserSessionId: OptionalOrNull(Type24.String()),
      syncedToLmsAt: OptionalOrNull(Type24.String())
    })
  )
);
var singleEventType = Type24.Object({
  id: Type24.Number(),
  type: Type24.String(),
  name: Type24.String(),
  details: Type24.Record(Type24.String(), Type24.Any()),
  time: Type24.String(),
  proctoringSessionId: Type24.Number(),
  anomalyRef: OptionalOrNull(Type24.Number())
});
var singleEvent = new SchemaValidator(singleEventType);
var proctoringEvent = new SchemaValidator(
  Type24.Object({
    events: Type24.Array(singleEventType),
    anomalies: Type24.Array(
      Type24.Object({
        type: Type24.String(),
        flagLevel: Type24.Number(),
        timeStart: OptionalOrNull(Type24.String()),
        timeEnd: OptionalOrNull(Type24.String()),
        id: Type24.Number(),
        comment: OptionalOrNull(Type24.String()),
        resolved: Type24.Boolean()
      })
    ),
    integrityScore: Type24.Number()
  })
);
var sessionNotes = new SchemaValidator(
  Type24.Array(
    Type24.Object({
      id: Type24.Number(),
      content: Type24.String(),
      timestamp: Type24.String()
    })
  )
);
var roomScanNotes = new SchemaValidator(
  Type24.Array(
    Type24.Object({
      id: Type24.Number(),
      content: Type24.String(),
      timestamp: Type24.Number()
    })
  )
);
var count = new SchemaValidator(Type24.Number());
var concatenationRequestId = new SchemaValidator(Type24.Object({ requestId: Type24.String() }));
var concatenationRequest = new SchemaValidator(
  Type24.Object({
    status: Type24.Union([
      Type24.Literal("POSTPROCESS_STARTED"),
      Type24.Literal("POSTPROCESS_COMPLETE"),
      Type24.Literal("POSTPROCESS_FAILED")
    ])
  })
);
var proctoringSession = new SchemaValidator(
  Type24.Object({
    id: Type24.Number(),
    uuid: Type24.String(),
    studentId: Type24.Number(),
    ipAddress: OptionalOrNull(Type24.String()),
    status: OptionalOrNull(sessionStatus),
    startTime: OptionalOrNull(Type24.String())
  })
);
var baseQuizResponseItem = new SchemaValidator(
  Type24.Object({
    id: Type24.Number(),
    sessionId: Type24.Number(),
    questionNo: Type24.Number(),
    answer: OptionalOrNull(schema_validators_default3.quizAnswer.schema),
    isAnswered: Type24.Boolean(),
    createdAt: Type24.String(),
    updatedAt: Type24.String()
  })
);
var studentQuizResponseItem = Type24.Object({
  ...baseQuizResponseItem.schema.properties,
  grading: Type24.Object({
    score: OptionalOrNull(Type24.Number()),
    notes: OptionalOrNull(Type24.String()),
    isUngraded: Type24.Boolean()
  })
});
var instructorQuizResponseItem = Type24.Object({
  ...baseQuizResponseItem.schema.properties,
  grading: Type24.Object({
    score: Type24.Number(),
    notes: Type24.String(),
    publishedScore: OptionalOrNull(Type24.Number()),
    publishedNotes: OptionalOrNull(Type24.String()),
    hasUnpublishedChanges: Type24.Boolean(),
    isUngraded: Type24.Boolean()
  }),
  gradedByAi: Type24.Boolean(),
  aiJustification: OptionalOrNull(Type24.String())
});
var studentQuizSessionData = new SchemaValidator(
  Type24.Object({
    responses: Type24.Array(studentQuizResponseItem),
    questions: Type24.Array(schema_validators_default3.studentQuizQuestion.schema)
  })
);
var instructorQuizSessionData = new SchemaValidator(
  Type24.Object({
    responses: Type24.Array(instructorQuizResponseItem),
    questions: Type24.Array(schema_validators_default3.instructorQuizQuestion.schema),
    syncError: OptionalOrNull(Type24.Boolean()),
    isSyncedToLms: OptionalOrNull(Type24.Boolean())
  })
);
var updateQuizResponseInput = new SchemaValidator(
  Type24.Object({
    id: Type24.Number(),
    score: OptionalOrNull(Type24.Number()),
    answer: OptionalOrNull(schema_validators_default3.quizAnswer.schema),
    isAnswered: OptionalOrNull(Type24.Boolean()),
    notes: OptionalOrNull(Type24.String())
  })
);
var paginatedEventsWithSessions = new SchemaValidator(
  PaginatedResults(Type24.Intersect([singleEventType, Type24.Object({ proctoringSession: proctoringSession.schema })]))
);
var sessionSummary = new SchemaValidator(
  Type24.Object({
    source: Type24.Union([Type24.Literal("ai"), Type24.Literal("liveProctor")]),
    summary: Type24.Object({
      summary: OptionalOrNull(Type24.String()),
      severe: OptionalOrNull(Type24.String()),
      major: OptionalOrNull(Type24.String()),
      minor: OptionalOrNull(Type24.String())
    })
  })
);
var supportChatResponse = new SchemaValidator(
  Type24.Object({
    message: Type24.String()
  })
);
var supportChatHistoryResponse = new SchemaValidator(
  Type24.Object({
    history: Type24.Array(
      Type24.Object({
        role: Type24.Union([Type24.Literal("user"), Type24.Literal("assistant")]),
        message: Type24.String(),
        timestamp: Type24.Number()
      })
    )
  })
);
var bedrockMessage = new SchemaValidator(
  Type24.Object({
    role: Type24.Union([Type24.Literal("user"), Type24.Literal("assistant")]),
    content: Type24.Array(
      Type24.Object({
        text: Type24.String()
      })
    )
  })
);
var assessmentSubmissionUploadUrlResponse = new SchemaValidator(
  Type24.Object({
    uploadUrl: Type24.String()
  })
);
var quizQuestionSubmissionUploadUrlResponse = new SchemaValidator(
  Type24.Object({
    uploadUrl: Type24.String(),
    fileName: Type24.String()
  })
);
var getAssessmentSubmissionResponse = new SchemaValidator(
  Type24.Array(schema_validators_default22.fileTypeSchema.schema)
);
var getStudentSubmissionsByAssessmentResponse = new SchemaValidator(
  Type24.Array(
    Type24.Object({
      files: Type24.Array(schema_validators_default22.fileTypeSchema.schema),
      uuid: Type24.String(),
      status: OptionalOrNull(sessionStatus),
      startTime: OptionalOrNull(Type24.String()),
      endTime: OptionalOrNull(Type24.String()),
      totalScore: OptionalOrNull(Type24.Number()),
      score: OptionalOrNull(Type24.Number()),
      hasUngraded: Type24.Boolean()
    })
  )
);
var getAssessmentSubmissionCount = new SchemaValidator(Type24.Number());
var ipAddress = new SchemaValidator(
  Type24.Object({
    ipAddress: Type24.String()
  })
);
var schema_validators_default23 = {
  startProctoring,
  lmsContext,
  testResults,
  proctoringEvent,
  recordingBlobInfo,
  uploadS3Url,
  url: uploadS3Url,
  ipAddress,
  sessionNotes,
  roomScanNotes,
  count,
  concatenationRequestId,
  concatenationRequest,
  proctoringSession,
  paginatedEventsWithSessions,
  singleEvent,
  sessionSummary,
  supportChatResponse,
  supportChatHistoryResponse,
  bedrockMessage,
  assessmentSubmissionUploadUrlResponse,
  quizQuestionSubmissionUploadUrlResponse,
  updateQuizResponseInput,
  studentQuizSessionData,
  instructorQuizSessionData,
  getAssessmentSubmissionResponse,
  getStudentSubmissionsByAssessmentResponse,
  getAssessmentSubmissionCount
};

// src/schemas/typebox/proctoring-session/state/schema-validators.ts
import { Type as Type25 } from "@sinclair/typebox";
var proctoringSessionState = new SchemaValidator(
  Type25.Object({
    status: Type25.Union([Type25.String(), Type25.Undefined()])
  })
);
var schema_validators_default24 = {
  proctoringSessionState
};

// src/schemas/typebox/proctoring-session/logger/access-code/schema-validators.ts
import { Type as Type26 } from "@sinclair/typebox";
var accessCodeDisableEvent = new SchemaValidator(
  Type26.Object({
    type: Type26.Literal("access code"),
    name: Type26.Literal("save password disabled"),
    time: Type26.Date(),
    details: Type26.Object({
      success: Type26.Boolean()
    })
  })
);
var accessCodeResetEvent = new SchemaValidator(
  Type26.Object({
    type: Type26.Literal("access code"),
    name: Type26.Literal("save password reset"),
    time: Type26.Date(),
    details: Type26.Object({
      success: Type26.Boolean()
    })
  })
);
var accessCodeAutofillEvent = new SchemaValidator(
  Type26.Object({
    type: Type26.Literal("access code"),
    name: Type26.Literal("autofill"),
    time: Type26.Date(),
    details: Type26.Object({
      success: Type26.Boolean(),
      password: Type26.Optional(Type26.String())
    })
  })
);
var schema_validators_default25 = {
  accessCodeDisableEvent,
  accessCodeResetEvent,
  accessCodeAutofillEvent
};

// src/schemas/typebox/proctoring-session/logger/clipboard/schema-validators.ts
import { Type as Type27 } from "@sinclair/typebox";
var clipboardDisableEvent = new SchemaValidator(
  Type27.Object({
    type: Type27.Literal("clipboard"),
    name: Type27.Literal("disable"),
    time: Type27.Date(),
    details: Type27.Object({
      success: Type27.Boolean()
    })
  })
);
var clipboardKeypressEvent = new SchemaValidator(
  Type27.Object({
    type: Type27.Literal("clipboard"),
    name: Type27.Literal("keypress"),
    time: Type27.Date(),
    details: Type27.Object({
      keypress: Type27.String(),
      value: Type27.Optional(Type27.String())
    })
  })
);
var schema_validators_default26 = {
  clipboardDisableEvent,
  clipboardKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/face-detection/schema-validators.ts
import { Type as Type28 } from "@sinclair/typebox";
var otherFaceDetectedEvent = new SchemaValidator(
  Type28.Object({
    type: Type28.Literal("face detection"),
    name: Type28.Literal("other"),
    time: Type28.Date(),
    details: Type28.Object({
      count: Type28.Number()
    })
  })
);
var targetFaceDetectedEvent = new SchemaValidator(
  Type28.Object({
    type: Type28.Literal("face detection"),
    name: Type28.Literal("target"),
    time: Type28.Date(),
    details: Type28.Object({
      count: Type28.Number()
    })
  })
);
var schema_validators_default27 = {
  otherFaceDetectedEvent,
  targetFaceDetectedEvent
};

// src/schemas/typebox/proctoring-session/logger/http/schema-validators.ts
import { Type as Type29 } from "@sinclair/typebox";
var httpWebNavigationEvent = new SchemaValidator(
  Type29.Object({
    type: Type29.Literal("web navigation"),
    name: Type29.Union([Type29.Literal("webRequest"), Type29.Literal("webNavigation")]),
    time: Type29.Date(),
    details: Type29.Object({
      url: Type29.String(),
      method: Type29.Optional(Type29.String()),
      frame: Type29.Optional(Type29.String())
    })
  })
);
var schema_validators_default28 = {
  httpWebNavigationEvent
};

// src/schemas/typebox/proctoring-session/logger/id/schema-validators.ts
import { Type as Type30 } from "@sinclair/typebox";
var idEvent = new SchemaValidator(
  Type30.Object({
    type: Type30.Literal("id"),
    name: Type30.Union([Type30.Literal("face id mismatch"), Type30.Literal("bypassed ai detection")]),
    time: Type30.Date(),
    details: Type30.Object({
      similarity: Type30.Optional(Type30.Number({ minimum: 0, maximum: 1 })),
      success: Type30.Optional(Type30.Boolean())
    })
  })
);
var schema_validators_default29 = {
  idEvent
};

// src/schemas/typebox/proctoring-session/logger/interrupt/schema-validators.ts
import { Type as Type31 } from "@sinclair/typebox";
var interruptTriggerEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("interrupt"),
    name: Type31.Literal("trigger"),
    time: Type31.Date(),
    details: Type31.Object({
      success: Type31.Boolean(),
      type: Type31.Union([
        Type31.Literal("webcam"),
        Type31.Literal("display"),
        Type31.Literal("screenShareInactive"),
        Type31.Literal("monitor count"),
        Type31.Literal("face recorder"),
        Type31.Literal("speaking"),
        Type31.Literal("enables_blocked_extension")
      ]),
      extNames: Type31.Optional(Type31.Array(Type31.String()))
    })
  })
);
var interruptResumeEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("interrupt"),
    name: Type31.Literal("resume"),
    time: Type31.Date(),
    details: Type31.Object({
      success: Type31.Boolean(),
      type: Type31.Union([
        Type31.Literal("webcam"),
        Type31.Literal("display"),
        Type31.Literal("screenShareInactive"),
        Type31.Literal("monitor count"),
        Type31.Literal("face recorder"),
        Type31.Literal("enables_blocked_extension")
      ])
    })
  })
);
var schema_validators_default30 = {
  interruptTriggerEvent,
  interruptResumeEvent
};

// src/schemas/typebox/proctoring-session/logger/keyboard/schema-validators.ts
import { Type as Type32 } from "@sinclair/typebox";
var keyboardKeypressEvent = new SchemaValidator(
  Type32.Object({
    type: Type32.Literal("keyboard"),
    name: Type32.Literal("keypress"),
    time: Type32.Date(),
    details: Type32.Object({
      value: Type32.String()
    })
  })
);
var schema_validators_default31 = {
  keyboardKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/live/schema-validators.ts
import { Type as Type33 } from "@sinclair/typebox";
var liveBuildAudioBridgeEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("live"),
    name: Type33.Literal("audio bridge"),
    time: Type33.Date(),
    details: Type33.Object({
      success: Type33.Boolean()
    })
  })
);
var liveProctorJoinedEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("live"),
    name: Type33.Literal("proctor joined"),
    time: Type33.Date(),
    details: Type33.Object({
      proctorId: Type33.String(),
      count: Type33.Optional(Type33.Number())
    })
  })
);
var liveProctorLeftEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("live"),
    name: Type33.Literal("proctor left"),
    time: Type33.Date(),
    details: Type33.Object({
      proctorId: Type33.String(),
      count: Type33.Optional(Type33.Number())
    })
  })
);
var liveJoinSessionEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("live"),
    name: Type33.Literal("join session"),
    time: Type33.Date(),
    details: Type33.Object({
      liveSessionId: Type33.String(),
      liveUserSessionId: Type33.String(),
      proctorIds: Type33.Optional(Type33.Array(Type33.String())),
      proctorGroupIds: Type33.Optional(Type33.Array(Type33.Number()))
    })
  })
);
var noProctorsEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("live"),
    name: Type33.Literal("no proctors"),
    time: Type33.Date(),
    details: Type33.Object({
      isOnJoin: Type33.Boolean()
    })
  })
);
var schema_validators_default32 = {
  liveBuildAudioBridgeEvent,
  liveProctorJoinedEvent,
  liveProctorLeftEvent,
  liveJoinSessionEvent,
  noProctorsEvent
};

// src/schemas/typebox/proctoring-session/logger/media/schema-validators.ts
import { Type as Type34 } from "@sinclair/typebox";
var logStartRecording = new SchemaValidator(Type34.String());
var schema_validators_default33 = {
  logStartRecording
};

// src/schemas/typebox/proctoring-session/logger/screenshot/schema-validators.ts
import { Type as Type35 } from "@sinclair/typebox";
var screenshotDisableEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("screenshot"),
    name: Type35.Literal("disable"),
    time: Type35.Date(),
    details: Type35.Object({
      success: Type35.Boolean()
    })
  })
);
var screenshotKeypressEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("screenshot"),
    name: Type35.Literal("keypress"),
    time: Type35.Date(),
    details: Type35.Object({
      keypress: Type35.String()
    })
  })
);
var schema_validators_default34 = {
  screenshotDisableEvent,
  screenshotKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/session/schema-validators.ts
import { Type as Type36 } from "@sinclair/typebox";
var startAssessmentEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("session"),
    name: Type36.Literal("start quiz"),
    time: Type36.Date(),
    details: Type36.Object({
      success: Type36.Boolean()
    })
  })
);
var endAssessmentEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("session"),
    name: Type36.Literal("end quiz"),
    time: Type36.Date(),
    details: Type36.Object({
      success: Type36.Boolean(),
      submitted: Type36.Optional(Type36.Boolean())
    })
  })
);
var endProctoringEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("session"),
    name: Type36.Literal("end proctoring"),
    time: Type36.Date(),
    details: Type36.Object({
      success: Type36.Boolean()
    })
  })
);
var schema_validators_default35 = {
  startAssessmentEvent,
  endAssessmentEvent,
  endProctoringEvent
};

// src/schemas/typebox/proctoring-session/logger/system/schema-validators.ts
import { Type as Type37 } from "@sinclair/typebox";
var connectionCheckEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("connection check"),
    time: Type37.Date(),
    details: Type37.Object({
      metrics: Type37.Any(),
      uploadSpeed: Type37.Number()
    })
  })
);
var systemResourceEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("system resources"),
    time: Type37.Date(),
    details: Type37.Object({
      cpuUsage: Type37.Number(),
      memoryUsage: Type37.Number()
    })
  })
);
var notInGeofenceEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("not in geofence"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var notInIpAddressRangeEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("not in ip address range"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var locationUnknownEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("location unknown"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var ipAddressUnknownEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("ip address unknown"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var installedExtensionsSnapshotEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("installed extensions snapshot"),
    time: Type37.Date(),
    details: Type37.Object({
      extensions: Type37.Array(
        Type37.Object({
          id: Type37.String(),
          name: Type37.String()
        })
      )
    })
  })
);
var runningApplicationsSnapshotEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("system"),
    name: Type37.Literal("running applications snapshot"),
    time: Type37.Date(),
    details: Type37.Object({
      applications: Type37.Array(Type37.String())
    })
  })
);
var schema_validators_default36 = {
  connectionCheckEvent,
  systemResourceEvent,
  notInGeofenceEvent,
  notInIpAddressRangeEvent,
  locationUnknownEvent,
  ipAddressUnknownEvent,
  installedExtensionsSnapshotEvent,
  runningApplicationsSnapshotEvent
};

// src/schemas/typebox/proctoring-session/logger/tab/schema-validators.ts
import { Type as Type38 } from "@sinclair/typebox";
var tabCloseOneEvent = new SchemaValidator(
  Type38.Object({
    type: Type38.Literal("tab"),
    name: Type38.Literal("close one"),
    time: Type38.Date(),
    details: Type38.Object({
      url: Type38.String(),
      title: Type38.String(),
      autoClose: Type38.Boolean()
    })
  })
);
var tabCreateEvent = new SchemaValidator(
  Type38.Object({
    type: Type38.Literal("tab"),
    name: Type38.Literal("create"),
    time: Type38.Date(),
    details: Type38.Object({
      url: Type38.String(),
      title: Type38.String()
    })
  })
);
var tabWhitelistEvent = new SchemaValidator(
  Type38.Object({
    type: Type38.Literal("tab"),
    name: Type38.Literal("whitelist"),
    time: Type38.Date(),
    details: Type38.Object({
      success: Type38.Boolean(),
      whiteList: Type38.Array(Type38.String())
    })
  })
);
var tabDisableEvent = new SchemaValidator(
  Type38.Object({
    type: Type38.Literal("tab"),
    name: Type38.Literal("disable"),
    time: Type38.Date(),
    details: Type38.Object({
      success: Type38.Boolean()
    })
  })
);
var tabFocusEvent = new SchemaValidator(
  Type38.Object({
    type: Type38.Literal("tab"),
    name: Type38.Literal("focus"),
    time: Type38.Date(),
    details: Type38.Object({
      focus: Type38.Boolean()
    })
  })
);
var schema_validators_default37 = {
  tabCloseOneEvent,
  tabCreateEvent,
  tabWhitelistEvent,
  tabDisableEvent,
  tabFocusEvent
};

// src/schemas/typebox/proctoring-session/logger/user-action/schema-validators.ts
import { Type as Type39 } from "@sinclair/typebox";
var sidePanelDetectedEvent = new SchemaValidator(
  Type39.Object({
    type: Type39.Literal("user action"),
    name: Type39.Literal("side panel detected"),
    time: Type39.Date(),
    details: Type39.Object({})
  })
);
var rightClickBlockedEvent = new SchemaValidator(
  Type39.Object({
    type: Type39.Literal("user action"),
    name: Type39.Literal("right click blocked"),
    time: Type39.Date(),
    details: Type39.Object({})
  })
);
var printingBlockedEvent = new SchemaValidator(
  Type39.Object({
    type: Type39.Literal("user action"),
    name: Type39.Literal("printing blocked"),
    time: Type39.Date(),
    details: Type39.Object({})
  })
);
var typedSignatureEvent = new SchemaValidator(
  Type39.Object({
    type: Type39.Literal("user action"),
    name: Type39.Literal("typed signature"),
    time: Type39.Date(),
    details: Type39.Object({
      signature: Type39.String()
    })
  })
);
var schema_validators_default38 = {
  sidePanelDetectedEvent,
  rightClickBlockedEvent,
  printingBlockedEvent,
  typedSignatureEvent
};

// src/schemas/typebox/proctoring-session/logger/worker/schema-validators.ts
import { Type as Type40 } from "@sinclair/typebox";
var detectedFace = Type40.Object({
  bbox: Type40.Object({
    normalizedX: Type40.Number(),
    normalizedY: Type40.Number(),
    normalizedWidth: Type40.Number(),
    normalizedHeight: Type40.Number()
  }),
  bboxRaw: Type40.Object({
    x: Type40.Number(),
    y: Type40.Number(),
    width: Type40.Number(),
    height: Type40.Number()
  }),
  score: Type40.Number(),
  gestures: Type40.Array(Type40.String()),
  similarity: OptionalOrNull(Type40.Number()),
  embedding: OptionalOrNull(Type40.Array(Type40.Number()))
});
var faceWorkerEvent = new SchemaValidator(
  Type40.Partial(
    Type40.Object({
      type: Type40.String(),
      name: Type40.String(),
      time: Type40.Date(),
      details: Type40.Object({
        topic: Type40.String(),
        metadata: OptionalOrNull(
          Type40.Object({
            duration: OptionalOrNull(Type40.Number())
          })
        ),
        detections: Type40.Array(Type40.Partial(detectedFace))
      })
    })
  )
);
var detectedObject = Type40.Object({
  bbox: Type40.Object({
    normalizedX: Type40.Number(),
    normalizedY: Type40.Number(),
    normalizedWidth: Type40.Number(),
    normalizedHeight: Type40.Number()
  }),
  bboxRaw: Type40.Object({
    x: Type40.Number(),
    y: Type40.Number(),
    width: Type40.Number(),
    height: Type40.Number()
  }),
  score: Type40.Number(),
  name: Type40.String()
});
var objectWorkerEvent = new SchemaValidator(
  Type40.Partial(
    Type40.Object({
      type: Type40.String(),
      name: Type40.String(),
      time: Type40.Date(),
      details: Type40.Object({
        topic: Type40.String(),
        metadata: OptionalOrNull(
          Type40.Object({
            duration: OptionalOrNull(Type40.Number())
          })
        ),
        detections: Type40.Array(Type40.Partial(detectedObject))
      })
    })
  )
);
var schema_validators_default39 = {
  faceWorkerEvent,
  objectWorkerEvent
};

// src/schemas/typebox/report/schema-validators.ts
var schema_validators_default40 = {};

// src/schemas/typebox/roster/schema-validators.ts
import { Type as Type41 } from "@sinclair/typebox";
var getRosterStatistics = new SchemaValidator(
  Type41.Object({
    TOTAL: Type41.Number(),
    ADMIN: Type41.Number(),
    INSTRUCTOR: Type41.Number(),
    STUDENT: Type41.Number()
  })
);
var privilegeGroupIds = new SchemaValidator(Type41.Array(Type41.Number()));
var schema_validators_default41 = {
  getRosterStatistics,
  privilegeGroupIds
};

// src/schemas/typebox/saml/schema-validators.ts
import { Type as Type42 } from "@sinclair/typebox";
var assertingPartyDetails = new SchemaValidator(
  Type42.Object({
    entityId: Type42.Union([Type42.String(), Type42.Null()]),
    wantAuthnRequestsSigned: Type42.Union([Type42.Boolean(), Type42.Null()]),
    singleSignOnServiceLocation: Type42.Union([Type42.String(), Type42.Null()]),
    singleSignOnServiceBindingUrn: Type42.Union([Type42.String(), Type42.Null()]),
    singleLogoutServiceLocation: Type42.Union([Type42.String(), Type42.Null()]),
    singleLogoutServiceResponseLocation: Type42.Union([Type42.String(), Type42.Null()]),
    singleLogoutServiceBindingUrn: Type42.Union([Type42.String(), Type42.Null()]),
    signingAlgorithms: Type42.Array(Type42.String()),
    verificationX509Credentials: Type42.Array(
      Type42.Object({
        certificate: Type42.String(),
        type: Type42.String()
      })
    ),
    encryptionX509Credentials: Type42.Array(
      Type42.Object({
        certificate: Type42.String(),
        type: Type42.String()
      })
    )
  })
);
var attributeMapping = new SchemaValidator(
  Type42.Object({
    email: Type42.Union([Type42.String(), Type42.Null()]),
    name: Type42.Union([Type42.String(), Type42.Null()]),
    role: Type42.Union([Type42.String(), Type42.Null()]),
    linkage: Type42.Union([Type42.String(), Type42.Null()])
  })
);
var roleMapping = new SchemaValidator(
  Type42.Object({
    id: Type42.Number(),
    attribute: Type42.String(),
    privilegeGroupId: Type42.Number(),
    requiredParentPrivilegeGroupId: OptionalOrNull(Type42.Integer())
  })
);
var relyingPartyRegistrationIds = {
  instituteId: Type42.String(),
  registrationId: Type42.String()
};
var relyingPartyRegistration = new SchemaValidator(
  Type42.Object({
    ...relyingPartyRegistrationIds,
    metadataLocation: Type42.Union([Type42.String(), Type42.Null()]),
    nameIdFormat: Type42.Union([Type42.String(), Type42.Null()]),
    assertingPartyDetails: Type42.Union([assertingPartyDetails.schema, Type42.Null()]),
    attributeMapping: Type42.Union([attributeMapping.schema, Type42.Null()]),
    roleMappings: Type42.Union([Type42.Array(roleMapping.schema), Type42.Null()]),
    linkUsersByEmail: Type42.Boolean(),
    enabled: Type42.Boolean()
  })
);
var getRelyingPartyRegistrations = new SchemaValidator(
  Type42.Object({
    content: Type42.Array(relyingPartyRegistration.schema)
  })
);
var getRelyingPartyRegistrationIds = new SchemaValidator(
  Type42.Object({
    content: Type42.Array(Type42.Object(relyingPartyRegistrationIds))
  })
);
var addRoleMapping = new SchemaValidator(
  Type42.Object({
    attribute: Type42.String(),
    privilegeGroupId: Type42.Number(),
    requiredParentPrivilegeGroupId: OptionalOrNull(Type42.Integer())
  })
);
var updateRelyingPartyRegistration = new SchemaValidator(
  Type42.Object({
    metadataLocation: Type42.Union([Type42.String(), Type42.Null()]),
    nameIdFormat: Type42.Union([Type42.String(), Type42.Null()]),
    assertingPartyDetails: Type42.Union([assertingPartyDetails.schema, Type42.Null()]),
    attributeMapping: Type42.Union([attributeMapping.schema, Type42.Null()]),
    linkUsersByEmail: Type42.Boolean(),
    enabled: Type42.Union([Type42.Boolean(), Type42.Null()])
  })
);
var createRelyingPartyRegistration = new SchemaValidator(
  Type42.Object({
    instituteId: Type42.String(),
    registrationId: Type42.Union([Type42.String(), Type42.Null()]),
    metadataLocation: Type42.Union([Type42.String(), Type42.Null()]),
    nameIdFormat: Type42.Union([Type42.String(), Type42.Null()]),
    assertingPartyDetails: Type42.Union([assertingPartyDetails.schema, Type42.Null()]),
    attributeMapping: Type42.Union([attributeMapping.schema, Type42.Null()]),
    roleMappings: Type42.Union([Type42.Array(addRoleMapping.schema), Type42.Null()]),
    linkUsersByEmail: Type42.Boolean(),
    enabled: Type42.Union([Type42.Boolean(), Type42.Null()])
  })
);
var getRoleMappingPresets = new SchemaValidator(
  Type42.Array(
    Type42.Object({
      preset: Type42.Union([Type42.Literal("STUDENT"), Type42.Literal("INSTRUCTOR"), Type42.Literal("ADMIN")]),
      privilegeGroupId: Type42.Number(),
      requiredParentPrivilegeGroupId: OptionalOrNull(Type42.Integer())
    })
  )
);
var schema_validators_default42 = {
  relyingPartyRegistration,
  getRelyingPartyRegistrations,
  getRelyingPartyRegistrationIds,
  addRoleMapping,
  updateRelyingPartyRegistration,
  createRelyingPartyRegistration,
  getRoleMappingPresets
};

// src/schemas/typebox/scratch-note/schema-validators.ts
import { Type as Type43 } from "@sinclair/typebox";
var createUploadGrant = new SchemaValidator(
  Type43.Object({
    id: Type43.String(),
    url: Type43.String()
  })
);
var getLinks = new SchemaValidator(
  Type43.Array(
    Type43.Object({
      id: Type43.String(),
      url: Type43.String(),
      uploadedAt: Type43.Optional(Type43.Number())
    })
  )
);
var schema_validators_default43 = {
  createUploadGrant,
  getLinks
};

// src/schemas/typebox/start-assessment/schema-validators.ts
import { Type as Type44 } from "@sinclair/typebox";
var checkUserAndAuthenticateResponse = new SchemaValidator(
  Type44.Object({
    eligible: Type44.Boolean(),
    exempted: Type44.Boolean(),
    error: Type44.Optional(
      Type44.Union([
        Type44.String(),
        Type44.Object({
          kind: Type44.Literal("incompatibleBrowser"),
          data: Type44.Object({
            compatibleBrowsers: Type44.Object({
              chrome: Type44.Boolean(),
              firefox: Type44.Boolean(),
              safari: Type44.Boolean()
            })
          })
        })
      ])
    ),
    platforms: Type44.Optional(
      Type44.Object({
        isExtension: Type44.Boolean(),
        isLockdown: Type44.Boolean(),
        isMobile: Type44.Boolean(),
        isChromeOs: Type44.Boolean(),
        isBrowser: Type44.Boolean()
      })
    ),
    versionSupported: Type44.Optional(Type44.Boolean())
  })
);
var getUploadContextResponse = new SchemaValidator(
  Type44.Object({
    quizName: OptionalOrNull(Type44.String()),
    courseName: OptionalOrNull(Type44.String()),
    studentName: OptionalOrNull(Type44.String()),
    fileFormats: Type44.Array(Type44.String()),
    count: Type44.Number(),
    canUpload: Type44.Boolean()
  })
);
var schema_validators_default44 = {
  checkUserAndAuthenticateResponse,
  getUploadContextResponse
};

// src/schemas/typebox/support/schema-validators.ts
import { Type as Type45 } from "@sinclair/typebox";
var callAccessCode = new SchemaValidator(
  Type45.Object({
    accessCode: OptionalOrNull(Type45.Number())
  })
);
var schema_validators_default45 = {
  callAccessCode
};

// src/schemas/typebox/system-check/schema-validators.ts
var schema_validators_default46 = {};

// src/schemas/typebox/user/schema-validators.ts
import { Type as Type46 } from "@sinclair/typebox";
var studentType = Type46.Object({
  id: Type46.Number(),
  uuid: Type46.String(),
  name: Type46.String()
});
var students = new SchemaValidator(Type46.Array(studentType));
var studentId = new SchemaValidator(Type46.Object({ id: Type46.Number() }));
var exemptions = new SchemaValidator(
  Type46.Union([
    Type46.Null(),
    Type46.Array(
      Type46.Object({
        userId: Type46.Integer()
      })
    )
  ])
);
var accessControlUserInfo = new SchemaValidator(
  Type46.Object({
    id: Type46.String(),
    name: Type46.String(),
    platform: Type46.String(),
    instituteId: Type46.String(),
    timezone: Type46.String(),
    privilegeGroupIds: Type46.Array(Type46.Number())
  })
);
var proctoringExemptions = new SchemaValidator(
  Type46.Array(
    Type46.Object({
      type: Type46.String(),
      userId: Type46.Integer(),
      accommodationNotes: Type46.Optional(Type46.String()),
      proctoringOptionProfileId: Type46.Optional(Type46.Integer())
    })
  )
);
var exemptionStatus = new SchemaValidator(
  Type46.Object({
    exempt: Type46.Boolean(),
    proctoringOption: Type46.Optional(proctoringOptionType)
  })
);
var language = new SchemaValidator(Type46.Union([Type46.Literal("en"), Type46.Literal("fr"), Type46.Null()]));
var standaloneAccount = new SchemaValidator(
  Type46.Object({
    id: Type46.String(),
    userIds: Type46.Array(Type46.String(), { minItems: 1 })
  })
);
var singleUseAccountEmailType = Type46.Union([
  Type46.Literal("candidate"),
  Type46.Literal("standalone"),
  Type46.Literal("standalone-live-register")
]);
var createSingleUseAccountInput = new SchemaValidator(
  Type46.Object({
    instituteUuid: Type46.String(),
    courseUuid: Type46.String(),
    assessmentUuid: Type46.String(),
    email: Type46.String(),
    firstName: Type46.String(),
    lastName: Type46.String(),
    expiryDate: Type46.String(),
    emailTemplateData: Type46.Optional(Type46.Record(Type46.String(), Type46.Unknown())),
    emailType: Type46.Optional(singleUseAccountEmailType)
  })
);
var sendStandaloneEmailRequest = new SchemaValidator(
  Type46.Object({
    emailTemplateData: Type46.Record(Type46.String(), Type46.Unknown()),
    emailType: singleUseAccountEmailType,
    accessCode: Type46.String()
  })
);
var notifications = new SchemaValidator(
  Type46.Array(
    Type46.Object({
      type: Type46.String(),
      details: OptionalOrNull(Type46.Unknown())
    })
  )
);
var loginCount = new SchemaValidator(
  Type46.Object({
    loginCount: Type46.Number()
  })
);
var hasShownWelcome = new SchemaValidator(
  Type46.Object({
    candidateWelcomeShownAt: Type46.Date()
  })
);
var schema_validators_default47 = {
  students,
  studentId,
  exemptions,
  proctoringExemptions,
  exemptionStatus,
  accessControlUserInfo,
  language,
  standaloneAccount,
  createSingleUseAccountInput,
  notifications,
  loginCount,
  hasShownWelcome,
  sendStandaloneEmailRequest
};
export {
  LUMINA_MAX_LIVE_SESSIONS,
  OptionalOrNull,
  PaginatedResults,
  SchemaValidator,
  schema_validators_default as adminSchemaValidators,
  schema_validators_default3 as assessmentSchemaValidators,
  schema_validators_default4 as authenticationSchemaValidators,
  schema_validators_default5 as basicAuthSchemaValidators,
  candidateInterviewOptionsBaseType,
  candidateInterviewOptionsGetType,
  candidateInterviewOptionsSaveType,
  chromeOsAccessType,
  schema_validators_default6 as courseSchemaValidators,
  schema_validators_default7 as downloadSchemaValidators,
  schema_validators_default8 as faceVerificationSchemaValidators,
  schema_validators_default9 as feedbackSchemaValidators,
  schema_validators_default10 as installationSchemaValidators,
  schema_validators_default12 as instituteSchemaValidators,
  schema_validators_default13 as integrationSchemaValidators,
  schema_validators_default14 as liveSchemaValidators,
  schema_validators_default15 as lmsInfoSchemaValidators,
  schema_validators_default16 as ltiSchemaValidators,
  luminaLiveSessionType,
  luminaOptionsPayload,
  luminaOptionsPayloadType,
  schema_validators_default17 as mediaSchemaValidators,
  schema_validators_default18 as oauthSchemaValidators,
  schema_validators_default19 as paymentSchemaValidators,
  schema_validators_default20 as permissionSchemaValidators,
  schema_validators_default21 as platformInfoSchemaValidators,
  schema_validators_default22 as proctoringConfigurationSchemaValidators,
  proctoringOptionProfile,
  proctoringOptionType,
  proctoringOptionsType,
  schema_validators_default11 as proctoringProfileSchemaValidators,
  schema_validators_default25 as proctoringSessionLoggerAccessCodeSchemaValidators,
  schema_validators_default26 as proctoringSessionLoggerClipboardSchemaValidators,
  schema_validators_default27 as proctoringSessionLoggerFaceDetectionSchemaValidators,
  schema_validators_default28 as proctoringSessionLoggerHttpSchemaValidators,
  schema_validators_default29 as proctoringSessionLoggerIdSchemaValidators,
  schema_validators_default30 as proctoringSessionLoggerInterruptSchemaValidators,
  schema_validators_default31 as proctoringSessionLoggerKeyboardSchemaValidators,
  schema_validators_default32 as proctoringSessionLoggerLiveSchemaValidators,
  schema_validators_default33 as proctoringSessionLoggerMediaSchemaValidators,
  schema_validators_default34 as proctoringSessionLoggerScreenshotSchemaValidators,
  schema_validators_default35 as proctoringSessionLoggerSessionSchemaValidators,
  schema_validators_default36 as proctoringSessionLoggerSystemSchemaValidators,
  schema_validators_default37 as proctoringSessionLoggerTabSchemaValidators,
  schema_validators_default38 as proctoringSessionLoggerUserActionSchemaValidators,
  schema_validators_default39 as proctoringSessionLoggerWorkerSchemaValidators,
  schema_validators_default23 as proctoringSessionSchemaValidators,
  schema_validators_default24 as proctoringSessionStateSchemaValidators,
  schema_validators_default40 as reportSchemaValidators,
  schema_validators_default41 as rosterSchemaValidators,
  schema_validators_default42 as samlSchemaValidators,
  schema_validators_default43 as scratchNoteSchemaValidators,
  schema_validators_default44 as startAssessmentSchemaValidators,
  schema_validators_default45 as supportSchemaValidators,
  schema_validators_default46 as systemCheckSchemaValidators,
  schema_validators_default47 as userSchemaValidators,
  schema_validators_default2 as verityOptionsSchemaValidators
};
//# sourceMappingURL=index.js.map